<template>
  <!-- 提单确认编辑 -->
  <div class="page-container" id="container">
    <!--导入箱货信息加载中的动画-->
    <div id="Loading" v-if="conShow">
      <div class="loader-inner ball-beat">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <!--      状态条 start-->
<!--    <scroll-pane ref="statusScrollPane" class="tags-view-wrapper">
      <div v-for="(item, index) in axisStatusList" :key="index">
        <div class="node-content">
          <img
            :src="item.iconStatus[item.index]"
            class="node-content-img"
          />
          <div
            v-if="index !== axisStatusList.length - 1"
            :class="
              item.completeStatus <= completeStatus
                ? 'solid-style'
                : 'dashed-style'
            "
          ></div>
          <div class="node-content-name">{{ item.text[0] }}</div>
          <span class="node-content-date">{{ item.text[1] }}</span>
        </div>
      </div>
    </scroll-pane>-->
    <!--      状态条 end-->
    <el-form ref="billEditFormRef" :rules="billEditFormRules" :model="ebBlPlan" class="form-panel"
             label-position="top" :disabled="ebBlPlan.approvalStatus === 'SUB' || ebBlPlan.approvalStatus === 'CRM'">
      <el-row type="flex" justify="start" align="top">
        <el-col :span="10" class="transceiver-module">
          <eb-party-info-bill
            @getEbPartyInfo="getEbPartyInfo"
            :ebParty.sync="ebParty"
            :ebOrder.sync="ebOrder"
            :ebBlPlan.sync="ebBlPlan"
            ref="ebPartyRef"
          />
        </el-col>
        <el-col :span="14" class="left-margin">
          <!-- 基本信息-start -->
          <div>
             <el-row class="title-panel-external">
                <div class="title-panel">
                <el-col :span="4">
                  <span class="title-text">基本信息</span>
                </el-col>
                <el-col :span="22">
                  <span class="title-text reminder">置灰栏位为不可更改项，如需更改请联系华贸操作</span>
                </el-col>
                </div>
              </el-row>
<!--             <el-row class="title-panel">
              <el-col>
                <el-col :span="2">
                  <span class="title-text">基本信息</span>
                </el-col>
                <el-col :span="10">
                  <span class="title-text" style="color:red">置灰栏位为不可更改项，如需更改请联系华贸操作</span>
                </el-col>
              </el-col>
            </el-row> -->
            <el-row class="content-panel">
              <el-col>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="订单号:" prop="orderNo">
                      <el-input
                        case="upper"
                        size="mini"
                        v-model="ebOrder.orderNo"
                        :title="ebOrder.orderNo"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="客户业务编号:"
                      prop="custBizNo"
                      disabled
                    >
                      <el-input
                        case="upper"
                        size="mini"
                        v-model="ebOrder.custBizNo"
                        :title="ebOrder.custBizNo"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="提单号:" prop="mblNo">
                      <el-input
                        case="upper"
                        size="mini"
                        v-model="ebOrder.mblNo"
                        :title="ebOrder.mblNo"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="船公司:">
                      <el-input
                        case="upper"
                        size="mini"
                        v-model="ebOrder.carrierName"
                        :title="ebOrder.carrierName"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-row :gutter="5">
                      <el-col :span="24">
                        <el-form-item label="付款方式:" prop="mblPaymentType">
                          <el-select
                            class="length_input"
                            size="mini"
                            v-model="ebOrder.mblPaymentType"
                            placeholder="请选择"
                            disabled
                            clearable
                          >
                            <el-option
                              v-for="item in hblPaymentTypeList"
                              :key="item.key"
                              :label="item.value"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>

                  <el-col :span="8">
                    <el-form-item label="付款地点:" prop="mblPaymentPlace">
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_po"
                        :query-method="associate_queryMethod_po"
                        class="input_length"
                        clearable
                        :query-length="0"
                        :default-first-option="true"
                        label-prop="portNameEn"
                        value-prop="mdPortId"
                        placeholder=""
                        v-model="ebOrder.mblPaymentPlace"
                        :title="ebOrder.mblPaymentPlace"
                        size="mini"
                        @change="changeHblPaymentPlace"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item label="运输条款:" prop="mblTransportTermFrom">
                          <el-select
                            class="length_input"
                            size="mini"
                            v-model="ebOrder.mblTransportTermFrom"
                            placeholder="请选择"
                            disabled
                          >
                            <el-option
                              v-for="item in hblTransportTermList"
                              :key="item.key"
                              :label="item.value"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <label slot="label" class="label_no"></label>
                          <el-select
                            class="length_input"
                            size="mini"
                            v-model="ebOrder.mblTransportTermTo"
                            placeholder="请选择"
                            disabled
                            clearable
                          >
                            <el-option
                              v-for="item in hblTransportTermList"
                              :key="item.key"
                              :label="item.value"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="订舱协议号(S/C NO.):" prop="agreementNo">
                      <el-input
                        case="upper"
                        size="mini"
                        v-model="ebOrder.agreementNo"
                        :title="ebOrder.agreementNo"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="N/A:" prop="nameAccount">
                      <el-input
                        case="upper"
                        size="mini"
                        v-model="ebOrder.nameAccount"
                        :title="ebOrder.nameAccount"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
<!--              <el-col>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-row>
                      <el-col :span="8">
                        <el-form-item label="场内:" prop="freeStorage">
                          <el-input
                            size="mini"
                            case="upper"
                            onkeyup="value=value.replace(/[^\d]/g,'')"
                            @change="sumFreeDaysChange"
                            v-model="ebOrder.freeStorage"
                            :title="ebOrder.freeStorage"
                            :min="0"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="场外:" prop="freeOfDetention">
                          &lt;!&ndash; <label slot="label" class="label_no"></label> &ndash;&gt;
                          <el-input
                            size="mini"
                            case="upper"
                            onkeyup="value=value.replace(/[^\d]/g,'')"
                            @change="sumFreeDaysChange"
                            v-model="ebOrder.freeOfDetention"
                            :title="ebOrder.freeOfDetention"
                            :min="0"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="免用天数:" prop="freeDays">
                          <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.freeDays"
                            :title="ebOrder.freeDays"
                            :min="0"
                            onkeyup="value=value.replace(/[^\d]/g,'')"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8">
                    <el-row>
                      <el-form-item
                        label="批复状态:"
                        prop="freeApprovalStatus"
                      >
                        <el-select
                          class="length_input"
                          size="mini"
                          v-model="ebOrder.freeApprovalStatus"
                          placeholder="请选择"
                          disabled
                        >
                          <el-option
                            v-for="item in approvalStatusList"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-row>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="批复状态:"
                      prop="freeApprovalStatus"
                    >
                      <el-select
                        class="length_input"
                        size="mini"
                        v-model="ebOrder.freeApprovalStatus"
                        placeholder="请选择"
                        disabled>
                        <el-option
                          v-for="item in approvalStatusList"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>-->
              <div>
                <el-col style="margin-top: 8px">
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item label="船公司销售人员:" prop="carrierSales">
                        <el-input
                          case="upper"
                          size="mini"
                          v-model="ebOrder.carrierSales"
                          :title="ebOrder.carrierSales"
                          disabled
                          ref="carrierSales"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="华贸分公司:">
                        <el-input
                          case="upper"
                          size="mini"
                          v-model="ebOrder.settleOfficeName"
                          :title="ebOrder.settleOfficeName"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="华贸客服:">
                        <el-input
                          case="upper"
                          size="mini"
                          v-model="ebOrder.csName"
                          :title="ebOrder.csName"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item label="华贸客服邮箱:">
                        <el-input
                          case="upper"
                          size="mini"
                          v-model="ebOrder.csEmail"
                          :title="ebOrder.csEmail"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="华贸客服电话:">
                        <el-input
                          case="upper"
                          size="mini"
                          v-model="ebOrder.csTel"
                          :title="ebOrder.csTel"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="华贸客服手机:">
                        <el-input
                          case="upper"
                          size="mini"
                          v-model="ebOrder.mobile"
                          :title="ebOrder.mobile"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </div>
            </el-row>
          </div>
          <!-- 基本信息-end -->
          <!-- 单证信息-start -->
          <div class="panel-top">
               <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col :span="4">
                  <span class="title-text">单证信息</span>
                </el-col>
                <el-col :span="22">
                  <span class="title-text reminder">路经美国、加拿大业务需选择【反恐舱单发送方式】</span>
                </el-col>
                </div>
              </el-row>
            <el-row class="content-panel">
              <el-col>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="单证联系人:" prop="custMblContact">
                      <el-input
                        case="upper"
                        size="mini"
                        maxlength="20"
                        v-model="ebBlPlan.custMblContact"
                        :title="ebBlPlan.custMblContact"
                        ref="custMblContact"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="单证联系人电话:" prop="custMblContactTel">
                      <el-input
                        case="upper"
                        size="mini"
                        maxlength="20"
                        v-model="ebBlPlan.custMblContactTel"
                        :title="ebBlPlan.custMblContactTel"
                        ref="custMblContactTel"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="单证联系人邮箱:" prop="custDocEmail">
                      <el-input
                        case="upper"
                        size="mini"
                        maxlength="50"
                        v-model="ebBlPlan.custDocEmail"
                        :title="ebBlPlan.custDocEmail"
                        ref="custDocEmail"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="签单方式:" prop="issueMode">
                      <el-select
                        class="length_input"
                        size="mini"
                        v-model="ebBlPlan.issueMode"
                        placeholder="请选择"
                        @change="onChangeIssMode"
                        ref="issueMode"
                      >
                        <el-option
                          v-for="item in issueModeList"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="签单地点:">
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_po"
                        :query-method="associate_queryMethod_po"
                        class="input_length"
                        clearable
                        :query-length="0"
                        :default-first-option="true"
                        label-prop="portNameEn"
                        value-prop="mdPortId"
                        placeholder=""
                        v-model="ebBlPlan.placeOfIssueName"
                        :title="ebBlPlan.placeOfIssueName"
                        size="mini"
                        @change="changePlaceOfIssueName"
                        case="upper"
                        ref="placeOfIssueName"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item label="正本份数:" prop="noOfOriginal">
                          <el-select
                            class="length_input"
                            size="mini"
                            v-model="ebBlPlan.noOfOriginal"
                            placeholder="请选择"
                            disabled
                            clearable
                          >
                            <el-option
                              v-for="item in noOfOriginalList"
                              :key="item.key"
                              :label="item.value"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="副本份数:" prop="noOfCopy">
                          <el-select
                            class="length_input"
                            size="mini"
                            v-model="ebBlPlan.noOfCopy"
                            placeholder="请选择"
                            disabled
                          >
                            <el-option
                              v-for="item in noOfOriginalList"
                              :key="item.key"
                              :label="item.value"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
              <el-col>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="AMS/ACI发送方式:">
                      <el-select
                        class="length_input"
                        size="mini"
                        @change="confirmChange"
                        v-model="ebBlPlan.amsSendMode"
                        placeholder="请选择"
                        clearable
                        ref="amsSendMode"
                      >
                        <el-option
                          v-for="item in amsSendModeList"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="SCAC CODE:" prop="scacCode">
                      <el-input
                        case="upper"
                        size="mini"
                        v-model="ebBlPlan.scacCode"
                        :title="ebBlPlan.scacCode"
                        maxlength="20"
                        ref="scacCode"
                        :disabled="hsaCheck"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="ACI/EMF CODE:" prop="aciCode">
                      <el-input
                        case="upper"
                        size="mini"
                        maxlength="20"
                        v-model="ebBlPlan.aciCode"
                        :title="ebBlPlan.aciCode"
                        :disabled="hsaCheck"
                        ref="aciCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="HBL No:" prop="houseBlNo">
                      <el-input
                        case="upper"
                        size="mini"
                        maxlength="20"
                        v-model="ebBlPlan.houseBlNo"
                        :title="ebBlPlan.houseBlNo"
                        ref="houseBlNo"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="截单时间:">
                      <el-date-picker
                        v-model="ebOrder.terminalTime"
                        :title="ebOrder.terminalTime"
                        style="width: 100%"
                        align="right"
                        type="date"
                        size="mini"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy-MM-dd HH:mm:ss"
                        :disabled="true"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="截VGM时间:">
                      <el-date-picker
                        v-model="ebOrder.cutVgmTime"
                        :title="ebOrder.cutVgmTime"
                        style="width: 100%"
                        align="right"
                        type="date"
                        size="mini"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy-MM-dd HH:mm:ss"
                        :disabled="true"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <!--                  <el-col :span="8">
                                      <el-form-item label="提单种类:" prop="billType">
                                        <el-select
                                          class="length_input"
                                          size="mini"
                                          v-model="ebBlPlan.billType"
                                          placeholder="请选择"
                                          ref="billType"
                                        >
                                          <el-option
                                            v-for="item in billTypeList"
                                            :key="item.key"
                                            :label="item.value"
                                            :value="item.key"
                                          >
                                          </el-option>
                                        </el-select>
                                      </el-form-item>
                                    </el-col>-->
                </el-row>
              </el-col>

            </el-row>
          </div>
          <!-- 单证信息-end -->
          <!-- 船期信息-start -->
          <div class="panel-top">
          <el-row class="title-panel-external">
          <div class="title-panel">
            <el-col>
             <span class="title-text">船期信息</span>
            </el-col>
          </div>
         </el-row>
            <el-row class="content-panel">
              <el-col>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-row>
                      <el-col :span="16">
                        <el-form-item
                          label="大船船名/航次:"
                          prop="vesselNameEn"
                        >
                          <el-associate
                            style="width: 100%"
                            :columns="associate_columns_vessel"
                            :query-method="associate_queryMethod_vessel"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="vesselName"
                            value-prop="mdVoyagePlanId"
                            placeholder=""
                            v-model="ebOrder.vesselNameEn"
                            :title="ebOrder.vesselNameEn"
                            size="mini"
                            @change="onChangeVessel"
                            :disabled="true"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item prop="voyage">
                          <label slot="label" class="label_no"></label>
                          <el-associate
                            style="width: 100%"
                            :columns="associate_columns_voyage"
                            :query-method="associate_queryMethod_voyage"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="voyage"
                            value-prop="mdVoyagePlanId"
                            placeholder=""
                            v-model="ebOrder.voyage"
                            :title="ebOrder.voyage"
                            size="mini"
                            @change="onChangeVoyage"
                            :disabled="true"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="大船开航日期:" prop="etd">
                      <el-date-picker
                        v-model="ebOrder.etd"
                        style="width: 100%"
                        align="right"
                        type="date"
                        size="mini"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                        :disabled="true"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="作业码头:" prop="terminalName">
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_terminal"
                        :query-method="associate_queryMethod_terminal"
                        class="input_length"
                        clearable
                        :query-length="0"
                        :default-first-option="true"
                        label-prop="facilityNameCn"
                        value-prop="facilityNameCn"
                        placeholder=""
                        v-model="ebOrder.terminalName"
                        :title="ebOrder.terminalName"
                        size="mini"
                        @change="onChangeTerminal"
                        :disabled="true"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-row>
                      <el-col :span="16">
                        <el-form-item label="实装大船船名/航次:">
                          <!--<el-associate style="width: 100%;"
                                      :columns="associate_columns_vessel"
                                      :query-method="associate_queryMethod_vessel"
                                      class="input_length"
                                      clearable
                                      :query-length="0"
                                      :default-first-option="true"
                                      label-prop="vesselNameEn"
                                      value-prop="mdVesselId"
                                      placeholder=""
                                      v-model="ebOrder.realVesselNameEn"
                                      size="mini"
                                      @change="onChangeRealVessel"
                                      disable
                        />-->
                          <el-input
                            v-model="ebOrder.realVesselNameEn"
                            :title="ebOrder.realVesselNameEn"
                            size="mini"
                            case="upper"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item>
                          <label slot="label" class="label_no"></label>
                          <el-input
                            v-model="ebOrder.realVoyage"
                            :title="ebOrder.realVoyage"
                            case="upper"
                            size="mini"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="实装大船开航日期:" prop="realEtd">
                      <el-date-picker
                        v-model="ebOrder.realEtd"
                        style="width: 100%"
                        align="right"
                        type="date"
                        size="mini"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                        :disabled="true"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                        <el-col :span="8">
                    <el-form-item
                      label="驳船作业码头:"
                      prop="bargeTerminalName"
                    >
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_terminal"
                        :query-method="associate_queryMethod_terminal"
                        class="input_length"
                        clearable
                        :query-length="0"
                        :default-first-option="true"
                        label-prop="facilityNameCn"
                        value-prop="facilityNameCn"
                        placeholder=""
                        v-model="ebOrder.bargeTerminalName"
                        :title="ebOrder.bargeTerminalName"
                        size="mini"
                        @change="onChangeBargeTerminal"
                        :disabled="true"
                      />
                    </el-form-item>
                  </el-col>
<!--                  <el-col :span="8">
                    <el-form-item label="大船截单日期:" prop="terminalTime">
                      <el-date-picker
                        v-model="ebOrder.terminalTime"
                        style="width: 100%"
                        align="right"
                        type="date"
                        size="mini"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                        :disabled="true"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>-->
                </el-row>
              </el-col>
              <el-col>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-row>
                      <el-col :span="16">
                        <el-form-item
                          label="驳船船名/航次:"
                          prop="bargeVesselName"
                        >
                          <el-associate
                            style="width: 100%"
                            :columns="associate_columns_vessel"
                            :query-method="associate_queryMethod_vessel"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="vesselNameEn"
                            value-prop="mdVoyagePlanId"
                            placeholder=""
                            v-model="ebOrder.bargeVesselName"
                            :title="ebOrder.bargeVesselName"
                            size="mini"
                            @change="onChangeBargeVessel"
                            :disabled="true"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item prop="bargeVoyage">
                          <label slot="label" class="label_no"></label>
                          <el-associate
                            style="width: 100%"
                            :columns="associate_columns_voyage"
                            :query-method="associate_queryMethod_voyage2"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="voyage"
                            value-prop="mdVoyagePlanId"
                            placeholder=""
                            v-model="ebOrder.bargeVoyage"
                            :title="ebOrder.bargeVoyage"
                            size="mini"
                            :disabled="true"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="驳船开航日期:">
                      <el-date-picker
                        v-model="ebOrder.bargeEtd"
                        style="width: 100%"
                        align="right"
                        type="date"
                        size="mini"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                        :disabled="true"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <!-- 船期信息-end -->
        </el-col>
      </el-row>
      <!-- 港口信息-start -->
      <el-row class="panel-top">
        <el-col>
           <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">港口信息</span>
                </el-col>
                </div>
              </el-row>
          <el-row class="content-panel">
            <el-col>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-row :gutter="5">
                    <el-col :span="8">
                      <el-form-item label="收货地:" prop="porName">
                        <el-associate
                          style="width: 100%"
                          :columns="associate_columns_po"
                          :query-method="associate_queryMethod_po"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="portNameEn"
                          value-prop="portNameEn"
                          placeholder=""
                          v-model="ebOrder.porCode"
                          :title="ebOrder.porCode"
                          size="mini"
                          @change="onChangePor"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <el-form-item>
                        <label slot="label" class="label_no"></label>
                        <el-input
                          case="upper"
                          size="mini"
                          v-model="ebOrder.porName"
                          :title="ebOrder.porName"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <el-row :gutter="5">
                    <el-col :span="8">
                      <el-form-item label="装货港:" prop="polName">
                        <el-associate
                          style="width: 100%"
                          :columns="associate_columns_po"
                          :query-method="associate_queryMethod_po"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="portNameEn"
                          value-prop="portNameEn"
                          placeholder=""
                          v-model="ebOrder.polCode"
                          :title="ebOrder.polCode"
                          size="mini"
                          @change="onChangePol"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <el-form-item>
                        <label slot="label" class="label_no"></label>
                        <el-input
                          case="upper"
                          size="mini"
                          v-model="ebOrder.polName"
                          :title="ebOrder.polName"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <el-row :gutter="5">
                    <el-col :span="8">
                      <el-form-item label="卸货/中转港:" prop="podName">
                        <el-associate
                          style="width: 100%"
                          :columns="associate_columns_po"
                          :query-method="associate_queryMethod_po"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="portNameEn"
                          value-prop="portNameEn"
                          placeholder=""
                          v-model="ebOrder.podCode"
                          :title="ebOrder.podCode"
                          size="mini"
                          @change="onChangePod"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <el-form-item>
                        <label slot="label" class="label_no"></label>
                        <el-input
                          case="upper"
                          size="mini"
                          v-model="ebOrder.podName"
                          :title="ebOrder.podName"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <el-row :gutter="5">
                    <el-col :span="8">
                      <el-form-item label="目的地:" prop="placeOfDeliveryName">
                        <el-associate
                          style="width: 100%"
                          :columns="associate_columns_po"
                          :query-method="associate_queryMethod_po"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="portNameEn"
                          value-prop="portNameEn"
                          placeholder=""
                          v-model="ebOrder.placeOfDeliveryCode"
                          :title="ebOrder.placeOfDeliveryCode"
                          size="mini"
                          @change="onChangeplaceOfDelivery"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <el-form-item>
                        <label slot="label" class="label_no"></label>
                        <el-input
                          case="upper"
                          size="mini"
                          v-model="ebOrder.placeOfDeliveryName"
                          :title="ebOrder.placeOfDeliveryName"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
            <el-col>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="提单收货地:" prop="blPorName">
                    <el-input
                      case="upper"
                      maxlength="50"
                      size="mini"
                      :title="ebBlPlan.blPorName"
                      v-model="ebBlPlan.blPorName" @input="() => {$forceUpdate()}"
                      ref="blPorName"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="提单装货港:" prop="blPolName">
                    <el-input
                      case="upper"
                      maxlength="50"
                      size="mini"
                      :title="ebBlPlan.blPolName"
                      v-model="ebBlPlan.blPolName" @input="() => {$forceUpdate()}"
                      ref="blPolName"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="提单卸货/中转港:" prop="blPodName">
                    <el-input
                      case="upper"
                      maxlength="50"
                      size="mini"
                      ref="blPodName"
                      :title="ebBlPlan.blPodName"
                      v-model="ebBlPlan.blPodName" @input="() => {$forceUpdate()}"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="提单目的地:" prop="blPlaceOfDeliveryName">
                    <el-input
                      case="upper"
                      size="mini"
                      :title="ebBlPlan.blPlaceOfDeliveryName"
                      v-model="ebBlPlan.blPlaceOfDeliveryName" @input="() => {$forceUpdate()}"
                      maxlength="50"
                      ref="blPlaceOfDeliveryName"
                    ></el-input>
                  </el-form-item>
                </el-col>

              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <!-- 港口信息-end -->
<!--      <el-row type="flex" justify="start" align="top" class="panel-top">
        &lt;!&ndash; 箱信息-start &ndash;&gt;
        <el-col :span="10">
          <el-row class="title-panel">
            <el-col>
              <span class="title-text">箱信息</span>
            </el-col>
          </el-row>
          <el-row class="content-panel" style="height: 174.28px">
            <el-col>
              <el-form-item label="箱型箱量汇总:">
                <el-input
                  case="upper"
                  size="mini"
                  v-model="ebBlPlan.ctnNum"
                  :title="ebBlPlan.ctnNum"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        &lt;!&ndash; 箱信息-end &ndash;&gt;
        <el-col :span="14" class="left-margin">

        </el-col>
      </el-row>-->
      <!-- 货物信息与计-start -->
      <!-- 货物信息与货物小计-start -->
      <el-row type="flex" justify="start" align="top">
        <el-col>
          <eb-cargo-info-bill
            @getCargoInfo="getEbCargoInfo"
            :ebCargo.sync="ebCargo"
            :ebOrder.sync="ebOrder"
            :ebBlPlan.sync="ebBlPlan"
            ref="ebCargoRef"
          />
        </el-col>
      </el-row>
      <!-- 货物信息与货物小计-end -->
      <!-- 箱货信息-start -->
      <el-row class="panel-top">
        <el-col>
        <el-row class="title-panel-external">
          <div class="title-panel">
            <el-col>
             <span class="title-text">箱货信息</span>
            </el-col>
          </div>
         </el-row>
          <el-row class="content-panel">
            <el-col style="margin-bottom:12px" class="handsontable-set blue-bg top-radius bottom-radius">
              <el-row class="enlarged-title-panel  blue-bg">
                <el-row class="enlarged-title">
                 <div class="enlarged-title-text">
                <span class="title-text">箱信息</span>
                </div>
                 <div class="enlarged-title-buttons">
<!--                      <el-button type="primary" size="mini" @click="addBillBoxInfo">新增</el-button>-->
                      <el-button type="danger" size="mini" @click="deleteEbBlPlanCtns">删除
                      </el-button>
                      <input hidden ref="excel-upload-input" class="excel-upload-input" type="file" accept=".xlsx, .xls"
                             @change="handleClick">
                      <el-button :loading="loading" style="margin-left:16px;" size="mini" type="primary"
                                 @click="handleUpload">
                        导入箱货信息
                      </el-button>
                      <el-button  style="margin-left:16px;" size="mini" type="primary"
                                 @click="quote">
                        引用
                      </el-button>
                </div>
                    <div class="enlarged-title-summary">
                      <span
                        style="
                          display: block;
                          width: 100%;
                          word-break: break-word;
                          color: red;
                          font-size: 12px;
                        "
                      >箱型箱量汇总:{{ ebBlPlan.ctnNum }}</span
                      >
                    </div>
                  </el-row>
                  </el-row>
                 <el-row class="content-panel blue-bg">
                   <el-col>
                    <el-row class="panel-top  handsontable-set">
                    <hot-table
                      ref="billBoxInfoTableRef"
                      :data-source="ebBlPlanCtns"
                      :settings="billBoxInfoTableSettings"
                      col-settings-key="billBoxInfoKey"
                      @cellClick="billBoxInfoTableCellClick"
                      @rowClick="billBoxInfoTableRowClick"
                      :rules="billBoxInfoTableRules"
                    >
                      <hot-column
                        :has-tip="true"
                        data="ctnNo"
                        title="<label style='color:red'>*</label>箱号"
                      >
                        <el-associate-editor
                          hot-editor
                          :allow-create="true"
                          style="width: 100%"
                          :columns="associate_columns_ctnNo"
                          :query-method="associate_queryMethod_ctnNo"
                          class="input_length"
                          clearable
                          case="upper"
                          :default-first-option="true"
                          label-prop="ctnNo"
                          value-prop="ctnNo"
                          placeholder=""
                          size="small"
                          name="ctnNo"
                          @change="boxCtnNoChange"
                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        data="sealNo"
                        title="<label style='color:red'>*</label>铅封号">
                        <el-input-editor
                          case="upper"
                          :controls="true"
                          hot-editor
                          name="sealNo"
                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        data="ctnSizeType"
                        title="<label style='color:red'>*</label>箱型"
                      >
                        <el-associate-editor
                          disabled
                          hot-editor
                          style="width: 100%"
                          :columns="associate_columns_ctnSizeType"
                          :query-method="associate_queryMethod_ctnSizeType"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="containerType"
                          value-prop="containerType"
                          placeholder=""
                          size="small"
                          name="ctnSizeType"
                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        data="noOfPackage"
                        title="<label style='color:red'>*</label>件数"
                        width="50">
                        <el-input-number-editor
                          case="upper"
                          :controls="false"
                          :precision="0"
                          :min="0"
                          hot-editor
                          name="noOfPackage"
                          @change="noOfPackageBoxChange"
                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        data="packageTypeName"
                        title="<label style='color:red'>*</label>包装单位">
                        <el-associate-editor
                          hot-editor
                          style="width: 100%"
                          :columns="associate_columns_ebBlPlanCtns_packageType"
                          :query-method="associate_queryMethod_ebBlPlanCtns_packageType"
                          @change="onChangeEbCtnsPackageType"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="enName"
                          value-prop="enName"
                          placeholder=""
                          name="packageTypeName"
                          size="small"
                          case="upper"
                          :disabled="true"
                        />
                      </hot-column>
                      <hot-column
                        type="numeric"
                        :numericFormat="{
                        pattern: '0,0.000',
                        culture: 'zh-CN',
                      }"
                        width="50"
                        :has-tip="true"
                        data="grossWeight"
                        title="<label style='color:red'>*</label>毛重(KGS)">
                        <el-input-number-editor
                          case="upper"
                          :controls="false"
                          :precision="3"
                          :min="0"
                          hot-editor
                          name="grossWeight"
                          @change="netWeightBoxChange"
                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        type="numeric"
                        :numericFormat="{
                        pattern: '0,0.000',
                        culture: 'zh-CN',
                      }"
                        data="cube"
                        title="<label style='color:red'>*</label>体积(CBM)"
                        width="50">
                        <el-input-number-editor
                          :controls="false"
                          :precision="3"
                          :min="0"
                          case="upper"
                          hot-editor
                          name="cube"
                          @change="cubeBoxChange"
                        />
                      </hot-column>
                      <!--                      <hot-column-->
                      <!--                          :has-tip="true"-->
                      <!--                          type="numeric"-->
                      <!--                          :numericFormat="{-->
                      <!--                        pattern: '0,0.000',-->
                      <!--                        culture: 'zh-CN',-->
                      <!--                      }"-->
                      <!--                          data="netWeight"-->
                      <!--                          title="净重(KGS)">-->
                      <!--                        <el-input-number-editor-->
                      <!--                            :controls="false"-->
                      <!--                            :precision="3"-->
                      <!--                            :min="0"-->
                      <!--                            case="upper"-->
                      <!--                            hot-editor-->
                      <!--                            name="netWeight"-->
                      <!--                        />-->
                      <!--                      </hot-column>-->
                      <hot-column
                        :has-tip="true"
                        data="ctnCompanyName"
                        title="箱属公司">
                        <el-input-editor
                          case="upper"
                          :controls="true"
                          hot-editor
                          name="ctnCompanyName"
                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        data="ctnCompanyCode"
                        title="箱主代码">
                        <el-input-editor
                          case="upper"
                          :controls="true"
                          hot-editor
                          name="ctnCompanyCode"
                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        data="isSoc"
                        title="SOC"
                        className="htCenter"
                        type="checkbox"
                        :checked-template="1"
                        checked-display="是"
                        :unchecked-template="0"
                        unchecked-display="否"
                        width="50">
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        data="fclLclFlag"
                        dictName="FCL_LCL"
                        title="<label style='color:red'>*</label>整拼标志">
                        <el-select-editor name="fclLclFlag" hot-editor>
                          <el-option
                            v-for="item in FCLLCL"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key"
                          >
                          </el-option>
                        </el-select-editor>
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        data="ncmNo"
                        title="NCM NO">
                        <el-input-editor
                          case="upper"
                          :controls="true"
                          hot-editor
                          name="ncmNo"
                        />
                      </hot-column>
                    </hot-table>
                    </el-row>
                   </el-col>
                  </el-row>
             </el-col>
             <el-col class="handsontable-set blue-bg border-radius">
              <el-row class="enlarged-title-panel blue-bg">
                <el-row class="enlarged-title">
                  <div class="enlarged-title-text">
                    <span class="title-text">货物信息</span>
                   </div>
                 <div class="enlarged-title-buttons">
                    <el-button type="primary" size="mini" @click="addBillCargoInfo">新增
                    </el-button>
                    <el-button
                      type="danger"
                      size="mini"
                      @click="deleteBillCargoInfo"
                    >删除
                    </el-button
                    >
                  </div>
               </el-row>
             </el-row>
                  <el-row class="content-panel  blue-bg">
                   <el-col>
                     <el-row class="panel-top  handsontable-set">
                    <hot-table
                      ref="billCargoInfoTableRef"
                      :data-source="ebCtns.ebBlPlanCtnCargo"
                      :settings="billCargoInfoTableSettings"
                      col-settings-key="billCargoInfoKey"
                      @cellClick="billCargoInfoTableCellClick"
                      @rowClick="billCargoInfoTableRowClick"
                      :rules="billCargoInfoTableRules"
                    >
                      <hot-column
                        :has-tip="true"
                        data="ctnNo"
                        title="<label style='color:red'>*</label>箱号">
                        <el-input-editor
                          disabled
                          case="upper"
                          :controls="true"
                          hot-editor
                          name="ctnNo"
                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        data="hsCode"
                        title="<label style='color:red'>*</label>HS CODE"
                      >
                        <el-input-editor
                          case="upper"
                          :controls="true"
                          hot-editor
                          name="hsCode"

                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        data="marks"
                        title="唛头">
                        <el-input-editor
                          case="upper"
                          :controls="true"
                          hot-editor
                          name="marks"

                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        data="cargoDescription"
                        title="<label style='color:red'>*</label>货物描述">
                        <el-input-editor
                          case="upper"
                          :controls="true"
                          hot-editor
                          name="cargoDescription"

                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        data="noOfPackage"
                        title="<label style='color:red'>*</label>件数">
                        <el-input-number-editor
                          :controls="false"
                          :precision="0"
                          :min="0"
                          case="upper"
                          hot-editor
                          @change="noOfPackageChange"
                          name="noOfPackage"

                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        data="packageTypeName"
                        title="<label style='color:red'>*</label>包装单位"
                      >
                        <el-associate-editor
                          hot-editor
                          style="width: 100%"
                          :columns="associate_columns_ebCtns_packageType"
                          :query-method="associate_queryMethod_ebCtns_packageType"
                          @focus="getEbCtnsIndex(ebCtnsIndex)"
                          @change="onChangeEbBlPlanCtnsPackageType"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="enName"
                          value-prop="enName"
                          placeholder=""
                          name="packageTypeName"
                          size="small"
                          case="upper"

                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        type="numeric"
                        :numericFormat="{
                        pattern: '0,0.000',
                        culture: 'zh-CN',
                        }"
                        data="grossWeight"
                        title="<label style='color:red'>*</label>毛重(KGS)">
                        <el-input-number-editor
                          case="upper"
                          :controls="false"
                          :precision="3"
                          :min="0"
                          @change="netWeightChange"
                          hot-editor
                          name="grossWeight"

                        />
                      </hot-column>
                      <hot-column
                        :has-tip="true"
                        type="numeric"
                        :numericFormat="{
                        pattern: '0,0.000',
                        culture: 'zh-CN',
                      }"
                        data="cube"
                        title="<label style='color:red'>*</label>体积(CBM)">
                        <el-input-number-editor
                          case="upper"
                          :controls="false"
                          :precision="3"
                          :min="0"
                          hot-editor
                          @change="cubeChange"
                          name="cube"

                        />
                      </hot-column>
                    </hot-table>
                    </el-row>
                  </el-col>
                 </el-row>
            </el-col>
              </el-row>
            </el-col>
          </el-row>
      <!-- 箱货信息-end -->
      <el-row type="flex" justify="start" align="top" class="panel-top">
        <el-col>
          <el-row :gutter="10">
            <!-- 船公司扩展信息-start -->
            <el-col :span="10">
              <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">船公司扩展信息</span>
                </el-col>
                </div>
              </el-row>
              <el-row class="content-panel" style="min-height: 200px">
                <el-col v-if="carrierExpand.length > 0">
                  <el-row :gutter="10">
                    <el-col
                      :span="12"
                      v-for="(widgetItem, index) in carrierExpand"
                      :key="index"
                    >
                      <el-form-item
                        :label="widgetItem.fieldName"
                        v-if="widgetItem.controlType === '01'"
                      >
                        <el-select
                          class="length_input"
                          size="mini"
                          v-model="bookingForm[widgetItem.fieldCode]"
                          placeholder="请选择"
                          case="upper"
                        >
                          <el-option
                            v-for="item in carrierSelectList[
                              widgetItem.controlBindCode
                            ]"
                            :key="item.key"
                            :label="item.value"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        :label="widgetItem.fieldName"
                        v-if="widgetItem.controlType === '02'"
                      >
                        <el-input
                          size="mini"
                          v-model="bookingForm[widgetItem.fieldCode]"
                          :title="bookingForm[widgetItem.fieldCode]"
                          placeholder="请输入"
                          case="upper"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col class="icon-wrp" v-else>
                    <img class="icon-none-info" :src="icon_none_info" alt="" />
                    <div class="txt-none-info">暂无船公司扩展信息</div>
                </el-col>
              </el-row>
            </el-col>
            <!-- 船公司扩展信息-end -->
            <!-- 备注信息-start -->
            <el-col :span="14">
               <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">备注信息</span>
                </el-col>
                </div>
              </el-row>
              <el-row class="content-panel" style="min-height: 200px">
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="客户提单确认备注:">
                        <el-input
                        style="margin-top:5px"
                          case="upper"
                          size="mini"
                          type="textarea"
                          :rows="7"
                          v-model="ebBlPlan.cusRemark"
                          :title="ebBlPlan.cusRemark"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="提单确认反馈:">
                        <el-input
                        style="margin-top:5px"
                          disabled
                          case="upper"
                          size="mini"
                          type="textarea"
                          :rows="7"
                          v-model="ebBlPlan.blRefuseReason"
                          :title="ebBlPlan.blRefuseReason"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
            <!-- 备注信息-end -->
          </el-row>
        </el-col>
      </el-row>

    </el-form>
    <el-row
      class="btn-container panel-top"
      type="flex"
      justify="end"
      align="middle"
    >
      <el-button
        type="primary" size="mini" :loading="loading"
        @click="saveBillEditInfo(2)" v-if="(ebBlPlan.approvalStatus ==='NEW' || ebBlPlan.approvalStatus ==='REJ')"
      >暂存草稿
      </el-button>
      <el-button
        type="primary" size="mini" :loading="loading"
        @click="saveBillEditInfo(3)" v-if="(ebBlPlan.approvalStatus ==='NEW' || ebBlPlan.approvalStatus ==='REJ')"
      >提交
      </el-button>
      <el-button
        type="primary" size="mini" v-if="(ebBlPlan.approvalStatus ==='SUB')" @click="cancelBillEditInfo"
      >撤销提交
      </el-button>
<!--      <el-button type="primary" size="mini" v-preventReClick @click="openReviseHistory">修改历史</el-button>-->
      <el-button
        type="primary"
        size="mini"
        @click="changeHistoryBox"
        v-preventReClick
      >修改历史
      </el-button>
      <el-button type="primary" size="mini">在线对单</el-button>
      <!-- <el-button type="primary" size="mini">关闭</el-button> -->
<!--      <change_history_up_box-->
<!--        :change-history-visible-flag-init="changeHistoryVisible"-->
<!--        :ebOrder="ebOrder"-->
<!--      />-->
      <change_history_box
        :change-history-visible-flag-init="changeHistoryBoxVisible"
        :ebOrder="ebOrder"
      />
    </el-row>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import {getBillManage} from "@/api/ladinBill";
import {queryMdCarrierInfo} from '@/api/queryMainSystem'
import ebCargoInfoBill from "@/components/EbCargoInfo/EbCargoInfoBill";
import ebPartyInfoBill from "@/components/EbPartyInfo/EbPartyInfoBill";
import ebCtn from "@/api/ebCtn";
import ebOrder from "@/api/ebOrder";
import {
  querybizTypeName,
  queryCtnSizeInfo,
  queryDictRows,
  queryPackageInfo,
  queryPoInfo,
  queryVoyageInfo
} from "@/api/commonService";
import {getBillEdit, queryPackageCode} from "@/api/ladinBill";
import {BillCargoInfoValidate, billEditFormRules, BoxInfoValidate} from '@/rules/billEdit_rules';
import ScrollPane from "@/layout/components/TagsView/ScrollPane";
import {querySpOrderStatus} from "@/api/status";
import {publicSave, revokeSub, saveAndSub} from "@/api/bookingRequest";
import changeHistoryUpBox from "@/views/lading-bill/ReviseHistoryBox.vue";
import autoFocusMixin from "@/mixin/autoFocus";
import changeHistoryBox from "@/views/booking/ReviseHistoryBox";
import {deteleEbBlPlanCtnById ,deteleEbFtPlanCtnCargoById} from "@/api/manifest";

export default {
  name: "ladingbillEdit",
  components: {
    ScrollPane,
    ebCargoInfoBill,
    ebPartyInfoBill,
    change_history_up_box: changeHistoryUpBox,
    change_history_box: changeHistoryBox,
  },
  mixins: [autoFocusMixin],
  data() {
    return {
      approvalStatusList: [],
      carrierSelectList: [],
      bookingForm: {},
      carrierExpand: [],
      billCargoInfoTableSelectRowIndex: null,
      ebCtns: {},
      billBoxInfoTableRowStatus: false,
      changeHistoryBoxVisible: false,
      loading: false,
      conShow: false,
      //货物信息
      ebCargo: {
        ebCargoD: [{}],
        ebCargoM: {},
      },
      //收发通信息
      ebParty: {
        //发货人
        ebPartySH: {partyType: "SH", rowStatus: 4},
        //收获人
        ebPartyCN: {partyType: "CN", rowStatus: 4, partyDescription: ""},
        //通知人
        ebPartyNT: {partyType: "NT", rowStatus: 4, partyDescription: ""},
        //第二通知人
        ebPartyNT2: {partyType: "NT2", rowStatus: 4},
        //第二通知人
        ebPartyDG: {partyType: "DG", rowStatus: 4},
        //真实发货人
        ebPartyRSH: {partyType: "RSH", rowStatus: 4},
        //真实收获人
        ebPartyRCN: {partyType: "RCN", rowStatus: 4},
        //真实通知人
        ebPartyRNT: {partyType: "RNT", rowStatus: 4},
      },
      ebBlPlanParty: [],
      nextImg: require("../../assets/img/status/nextImg.png"),
      ringImg: require("../../assets/img/status/ringImg.png"),
      waitImg: require("../../assets/img/status/waitImg.png"),
      warnImg: require("../../assets/img/status/warnImg.png"),
      successImg: require("../../assets/img/status/successImg.png"),
      icon_none_info: require("../../assets/images/dashboard_imgs/shipping-company.png"),
      moreInfoVisible: false,
      completeStatus: 0,
      ebBlPlanCtnsIndex: 0,
      ebCtnsIndex: 0,
      axisStatusList: [
        {
          index: "0",
          text: ["订舱草稿", null],
          iconStatus: {
            "0": require("@/assets/img/status/status1.png"),
            "2": require("@/assets/img/status/status9.png"),
          },
        },
        {
          index: "2",
          text: ["订舱已提交", null],
          iconStatus: {
            "0": require("@/assets/img/status/status2.png"),
            "2": require("@/assets/img/status/status8.png"),
          },
        },
        {
          index: "2",
          text: ["订舱已成功", null],
          iconStatus: {
            "0": require("@/assets/img/status/status3.png"),
            "2": require("@/assets/img/status/status7.png"),
          },
        },
        {
          index: "2",
          text: ["已发送舱单", null],
          iconStatus: {
            "0": require("@/assets/img/status/status4.png"),
            "2": require("@/assets/img/status/status6.png"),
          },
        },
        {
          index: "2",
          text: ["已做提单确认", null],
          iconStatus: {
            "0": require("@/assets/img/status/status5.png"),
            "2": require("@/assets/img/status/status9.png"),
          },
        },
      ],
      //订单
      ebOrder: {
        ebOrderId: "",
        vesselNameEn: "",
        synchronizeToDetail: false,
        mblTransportTermFrom: "CY",
        mblTransportTermTo: "CY",
        custContact: "",
        custContactTel: "",
        custContactEmail: "",
        orderStatus: "NEW",
        bizTypeCode: "",
        bizTypeName: "",
        bizBigTypeCode: "MFE",
        bizBigTypeName: "海运集装箱出口",
        inputMethond: "M",
        orderType: "F",
        isCancelApply: 0,
        isLcl: 0,
        // carrierId: "1", //根据对话框中选择的船公司赋值?
        carrierName: "", //根据对话框中选择的船公司赋值?
        isDeleted: 0,
        vgmStatus: "UNSENT",
        vgmApprovalStatus: "NEW",
        transferStatus: 0,
        rowStatus: 4,
        ctnNum: "",
        settleOfficeName: "",
        ebOrderStatus: "NEW",
        voyage: "",
        bargeVoyage: "",
        mblPaymentType: "",
        mblPaymentPlace: "",
        placeOfIssueName: "",
        freeStorage: "",
        freeOfDetention: "",
        freeStatus: "",
        carrierSales: "",
        porName: "",
        polName: "",
        podName: "",
        potName: "",
        placeOfDeliveryName: "",
        bargeTransitPortCode: "",
        bookingFeedBack: "",
        orderRemark: "",
        freeDays: "",
        csName: "",
        csEmail: "",
        csTel: "",
        mobile: "",
        ebCargos: [],
      },
      ebBlPlan: {
        custDocEmail: "",
        custMblContactTel: "",
        custMblContact: "",
        ebOrderId: "",
        ebBlPlanId: "",
        billType: "",
        scac: "",
        aciCode: "",
        amsSendMode: "",
        ctnNum: "",
        houseBlNo: "",
        cusRemark: "",
        blRefuseReason: "",
        blPotName: "",
        blPodName: "",
        blPorName: "",
        blPolName: "",
        issueMode: "C", //正本提单
        noOfOriginal: "3", //THREE(3)
        noOfCopy: "0", //ZERO(0)
        blPlaceOfDestName: "",
        blPlaceOfDeliveryName: "",
        placeOfDestName: "",
        placeOfDestCode: "",
        approvalStatus: "NEW",
        marks: "",
        commodity: "",
        noOfPackages: "",
        packageTypeName: "",
        grossWeight: "",
        cube: "",
        netWeight: "",
        hsCode: "",
        jsonInfo: ""
      },
      ebBlPlanCtnCargo: {},
      billEditFormRules: {},
      //当前箱货明细信息
      currentebBlPlanCtnCargo: [],
      // 箱信息
      ebBlPlanCtns: [],
      //修改历史弹出框
      changeHistoryVisible: false,
      //包装联想控件
      associate_columns_ebBlPlanCtns_packageType: [
        {
          title: "中文名称",
          field: "cnName",
        },
        {
          title: "英文名称",
          field: "enName",
        },
        {
          title: "代码",
          field: "mdChargeunitCode",
        },
      ],
      //包装联想控件
      associate_columns_ebCtns_packageType: [
        {
          title: "中文名称",
          field: "cnName",
        },
        {
          title: "英文名称",
          field: "enName",
        },
        {
          title: "代码",
          field: "mdChargeunitCode",
        },
      ],
      //大船/驳船船名联想控件
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
      //航次联想控件
      associate_columns_voyage: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
        {
          title: "航次代码",
          field: "voyageCode",
        },
      ],
      //(驳船)作业码头联想控件
      associate_columns_terminal: [
        {
          title: "码头简称",
          field: "shortName",
        }, {
          title: "助记码",
          field: "mnemonicCode",
        }, {
          title: "码头全称",
          field: "facilityNameCn",
        }
      ],
      //收货地/装货港/中转港/卸货港/交货地联想控件
      associate_columns_po: [
        {
          title: "英文名称",
          field: "portNameEn",
        },
        {
          title: "中文名称",
          field: "portNameCn",
        },
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "海港代码",
          field: "portCode",
        },
      ],
      billBoxInfoTableSettings: {
        height: 200,
        autoColumnSize: true,
        stretchH: "none", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      billCargoInfoTableSettings: {
        height: 200,
        autoColumnSize: true,
        stretchH: "none", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      billBoxInfoTableRules: {},
      billCargoInfoTableRules: {},
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      //箱号联想控件
      associate_columns_ctnNo: [
        {
          title: "箱号",
          field: "ctnNo",
        },
      ],
      //箱型联想控件
      associate_columns_ctnSizeType: [
        {
          title: "箱型尺寸",
          field: "containerType",
        },
      ],
      //箱信息列表选中行下标
      billBoxInfoTableSelectRowIndex: null,
      //付款方式
      hblPaymentTypeList: [],
      //运输条款
      hblTransportTermList: [],
      //签单方式
      issueModeList: [],
      //正本/副本
      noOfOriginalList: [],
      //提单种类
      billTypeList: [],
      FCLLCL: [],
      freeStatus: [],
      hsaCheck: false,
      //AMS/ACI发送方式
      amsSendModeList: [],
      ctnSizeTypeMap: new Map(),
      ctnSizeTypeMapAll: '',
      preAmsSendMode: ''
    };
  },
  async created() {

  },
  mounted() {
    let self = this;
    console.log(this.$route.params)
    self.getSelectList();
    self.billEditFormRules = JSON.parse(JSON.stringify(billEditFormRules));
    self.$nextTick(() => {
      self.$refs.billEditFormRef.clearValidate();
    });
    //报错，导致后续代码无法执行，无法初始化数据，billEditFormRef已包括整个表单。
      //self.$refs.ebCargoRef.clearValidate();
    /*  self.$refs.cargoStatisticsFormRef.clearValidate(); */
    // 处理表格自适应问题
    let _this = this;
    _this.resizeObserver = new ResizeObserver((entries) => {
      _this.$nextTick(() => {
        _this.$refs.billBoxInfoTableRef.resizeTo(
          entries[0].target.clientWidth - 52
        );
        _this.$refs.billCargoInfoTableRef.resizeTo(
          entries[0].target.clientWidth - 52
        );
      });
    });
    _this.resizeObserver.observe(document.getElementById("container"));
    //接收订舱管理界面-制作提单
    // this.ebBlPlan = this.$route.params.ebBlPlan ? this.$route.params.ebBlPlan : {};
    this.ebBlPlanParties = this.$route.params.ebBlPlanParties;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    /**/
    let data = {
      sysUserId: userInfo.userId
    };
    this.getUser(data);
    _this.lineHighlight(1);
    // _this.querySpOrderStatus();
  },
  // activated() {
  //   let _this = this;
  //   this.ebBlPlan = this.$route.params.ebBlPlan ? this.$route.params.ebBlPlan : {}
  //   this.ebBlPlanParties = this.$route.params.ebBlPlanParties;
  //   let userInfo = JSON.parse(localStorage.getItem("userInfo"));
  //   /**/
  //   let data = {
  //     sysUserId: userInfo.userId
  //   };
  //   _this.getUser(data);
  // },
  watch: {
    "ebBlPlan.scacCode": function () {
      let self = this;
      self.$nextTick(function () {
        self.hsaChange()
      });
    },
    "ebBlPlan.aciCode": function () {
      let self = this;
      self.$nextTick(function () {
        self.hsaChange()
      });
    },
    "ebBlPlan.houseBlNo": function () {
      let self = this;
      self.$nextTick(function () {
        self.hsaChange()
      });
    },
    "ebBlPlan.amsSendMode": function () {
      let self = this;
      let amsSendMode = self.ebBlPlan.amsSendMode;
      if (amsSendMode === "CS") {
        let newRules = JSON.parse(JSON.stringify(this.billEditFormRules));
        newRules['houseBlNo'] = [{required: true, message: '请输入', trigger: 'blur'},]
        /*newRules['scacCode'] = [{required: true, message: '请输入', trigger: 'blur'},]
        newRules['aciCode'] = [{required: true, message: '请输入', trigger: 'blur'},]*/
        this.billEditFormRules = newRules;
      } else {
        let newRules = JSON.parse(JSON.stringify(this.billEditFormRules));
        delete newRules['houseBlNo']
        delete newRules['scacCode']
        delete newRules['aciCode']
        this.billEditFormRules = newRules;
      }
      if (amsSendMode === "SS" || amsSendMode === "SR" || amsSendMode === "FS") {
        this.hsaCheck = true;
      }else {
        this.hsaCheck = false;
      }
      setTimeout(() => {
       // this.$refs.billEditFormRef.clearValidate();
        this.$forceUpdate();
      });
      self.$nextTick(function () {
        self.hsaChange();
      });
      this.$forceUpdate();
    },
    "ebBlPlan.issueMode": function () {
      let self = this;
      if (self.ebBlPlan.issueMode === "O") {
        self.ebBlPlan.noOfOriginal = "3";
        self.ebBlPlan.noOfCopy = "3";
      } else {
        self.ebBlPlan.noOfOriginal = "1";
        self.ebBlPlan.noOfCopy = "0";
      }
    },
    "ebBlPlan.packageTypeName": function () {
      let self = this;
      // self.ebBlPlanCtns.forEach((item) => {
      //   item.packageTypeCode = self.ebBlPlan.packageTypeCode
      //   item.packageTypeName = self.ebBlPlan.packageTypeName
      // });
      self.confirmPackageType();
    }
  },
  methods: {
    changeHistoryBox() {
      this.changeHistoryBoxVisible = !this.changeHistoryBoxVisible;
    },
    validateAutoFocus() {
      this.autoFocus(this.ebBlPlan, this.billEditFormRules);
    },
    openReviseHistory() {
      this.changeHistoryVisible = !this.changeHistoryVisible;
    },
    cancelBillEditInfo() {
      let self = this;
      let dataType = "MBL"
      if (self.ebServiceItemsBuffer) {
        self.ebServiceItemsBuffer.forEach(item =>{
          if (item.serviceCode === 'HBL') {
            dataType = 'HBL';
          }
        })
      }
      self.$coreMethods.confirm(
        function () {
          revokeSub({
            ebOrderIds: [self.ebOrderId],
            dataType: dataType
          }).then((res) => {
            if (res.success) {
              self.getBillEditData(self.ebOrderId);
              self.$coreMethods.message("success", "撤销提交成功");
            } else {
              self.$coreMethods.message("error", "撤销提交失败");
            }
          });
        },
        function () {
        },
        false,
        "是否执行撤销操作？"
      );
    },
    getUser(data) {
      let self = this;
      ebOrder.searchUser(data).then((res) => {
        if (res.success) {
          self.ebBlPlan.custMblContact = res.records.userNameCn;
          self.ebBlPlan.custDocEmail = res.records.email;
          self.ebBlPlan.custMblContactTel = res.records.tel;
        }
        self.ebBlPlan.marks = "";
        self.ebBlPlan.commodity = "";
        self.ebBlPlan.noOfPackages = "";
        self.ebBlPlan.packageTypeName = "";
        self.ebBlPlan.packageTypeCode = "";
        self.ebBlPlan.grossWeight = "";
        self.ebBlPlan.cube = "";
        self.ebBlPlan.hsCode = "";
        /**跳转到此界面接收值**/
        if (self.$route.params.ebOrderId) {
          self.ebOrderId = self.$route.params.ebOrderId;
          //订舱管理-编辑
          if (self.ebOrderId !== undefined) {
            self.getBillEditData(self.ebOrderId);
          }
        }
      });
    },
    //获取数据字典
    getCarrierSelectList(params) {
      queryDictRows(params).then((res) => {
        this.carrierSelectList = res;
      });
    },
    netWeightChange(currentValue, oldValue) {
      let netWeight = 0
      this.ebCtns.ebBlPlanCtnCargo.forEach(item => {
        if (item.grossWeight) netWeight += parseFloat(item.grossWeight)
      })

      if (currentValue && oldValue) {
        netWeight = netWeight + parseFloat(currentValue) - parseFloat(oldValue)
      } else if (currentValue && !oldValue) {
        netWeight = netWeight + currentValue
      } else if (!currentValue && oldValue) {
        netWeight = netWeight - oldValue
      }
      this.ebCtns.grossWeight = netWeight
      let netWeight1 = 0;
      this.ebBlPlanCtns.forEach(item => {
        if (item.grossWeight) netWeight1 += parseInt(item.grossWeight)
      })
      this.ebBlPlan.grossWeight = netWeight1
      this.$forceUpdate()
    },
    cubeChange(currentValue, oldValue) {
      let cube = 0
      this.ebCtns.ebBlPlanCtnCargo.forEach(item => {
        if (item.cube) cube += parseFloat(item.cube)
      })
      if (currentValue && oldValue) {
        cube = cube + parseFloat(currentValue) - parseFloat(oldValue)
      } else if (currentValue && !oldValue) {
        cube = cube + currentValue
      } else if (!currentValue && oldValue) {
        cube = cube - oldValue
      }
      this.ebCtns.cube = cube
      let cube1 = 0;
      this.ebBlPlanCtns.forEach(item => {
        if (item.cube) cube1 += parseInt(item.cube)
      })
      this.ebBlPlan.cube = cube1
      this.$forceUpdate()
    },
    cubeBoxChange(currentValue, oldValue) {
      let cube = 0
      this.ebBlPlanCtns.forEach(item => {
        if (item.cube) cube += parseFloat(item.cube)
      })
      if (currentValue && oldValue) {
        cube = cube + parseFloat(currentValue) - parseFloat(oldValue)
      } else if (currentValue && !oldValue) {
        cube = cube + currentValue
      } else if (!currentValue && oldValue) {
        cube = cube - oldValue
      }
      this.ebBlPlan.cube = cube
      this.$forceUpdate()
    },
    netWeightBoxChange(currentValue, oldValue) {
      let netWeight = 0
      this.ebBlPlanCtns.forEach(item => {
        if (item.grossWeight) netWeight += parseFloat(item.grossWeight)
      })
      if (currentValue && oldValue) {
        netWeight = netWeight + parseFloat(currentValue) - parseFloat(oldValue)
      } else if (currentValue && !oldValue) {
        netWeight = netWeight + currentValue
      } else if (!currentValue && oldValue) {
        netWeight = netWeight - oldValue
      }
      this.ebBlPlan.grossWeight = netWeight
      this.$forceUpdate()
    },
    noOfPackageBoxChange(currentValue, oldValue) {
      let noOfPackage = 0
      this.ebBlPlanCtns.forEach(item => {
        if (item.noOfPackage) noOfPackage += parseInt(item.noOfPackage)
      })

      if (currentValue && oldValue) {
        noOfPackage = noOfPackage + parseFloat(currentValue) - parseFloat(oldValue)
      } else if (currentValue && !oldValue) {
        noOfPackage = noOfPackage + currentValue
      } else if (!currentValue && oldValue) {
        noOfPackage = noOfPackage - oldValue
      }
      this.ebBlPlan.noOfPackages = noOfPackage
      this.$forceUpdate()
    },
    noOfPackageChange(currentValue, oldValue) {
      let noOfPackage = 0;
      this.ebCtns.ebBlPlanCtnCargo.forEach(item => {
        if (item.noOfPackage) noOfPackage += parseInt(item.noOfPackage)
      })

      if (currentValue && oldValue) {
        noOfPackage = noOfPackage + parseFloat(currentValue) - parseFloat(oldValue);
      } else if (currentValue && !oldValue) {
        noOfPackage = noOfPackage + currentValue
      } else if (!currentValue && oldValue) {
        noOfPackage = noOfPackage - oldValue
      }
      this.ebCtns.noOfPackage = noOfPackage
      let noOfPackage1 = 0;
      this.ebBlPlanCtns.forEach(item => {
        if (item.noOfPackage) noOfPackage1 += parseInt(item.noOfPackage)
      })
      this.ebBlPlan.noOfPackages = noOfPackage1
      this.$forceUpdate()
    },
    /**
     * 箱信息行高亮
     */
    lineHighlight(number) {
      let self = this;
      self.$refs.billBoxInfoTableRef.hotInstance.addHookOnce(
        "afterLoadData",
        function () {
          self.$nextTick(function () {
            self.$refs.billBoxInfoTableRef.hotInstance.selectCell(number - 1, 1);
          });
        }
      );
    },
    /*
     *获取状态条
    */
    querySpOrderStatus(id) {
      let self = this;
      let data = {
        stageCode: "MBL",
        goOrderId: id,
      };
      querySpOrderStatus(data)
        .then((res) => {
          if (res.success) {
            let newAxisStatusList = self.axisStatusList
            res.records.node.forEach((item, index) => {
              newAxisStatusList[index]['index'] = item['index'];
              newAxisStatusList[index]['text'] = item['text'];
            })

            self.axisStatusList = newAxisStatusList
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //初始化界面根据ebOrderId获取界面数据
    getBillEditData(ebOrderId) {
      let params = {
        ebOrderId: ebOrderId,
      };
      let self = this;
      getBillEdit(params).then((res) => {
        if (res.success) {
          self.ebCargo.ebCargoD = [];
          for (let key in res.records) {
            if (res.records[key]) {
              self.ebOrder[key] = res.records[key]
            }
          }
          delete self.ebOrder.orderStatus;
          if(res.records.ebBlPlan){
            self.ebBlPlan = Object.assign({}, self.ebBlPlan, res.records.ebBlPlan);
            // let billEbPlan = JSON.parse(JSON.stringify(res.records.ebBlPlan))
            // let userInfo = JSON.parse(localStorage.getItem("userInfo"));
            // let data = {
            //   sysUserId: userInfo.userId
            // };
            // self.getUser(data);
            self.ebBlPlan.noOfOriginal = res.records.ebBlPlan.noOfOriginal;
            self.ebBlPlan.noOfCopy = res.records.ebBlPlan.noOfCopy;
            self.ebBlPlan.ctnNum = res.records.ebBlPlan.ctnNum;
            self.ebBlPlanCtns = res.records.ebBlPlan.ebBlPlanCtn || [];
          }
          if (self.ebBlPlan.approvalStatus === undefined) {
            self.ebBlPlan.approvalStatus = "NEW";
          }
          self.billBoxInfoTableSelectRowIndex = 0;
          self.billBoxInfoTableRowStatus = true;
          if (self.ebBlPlan.placeOfIssueId === undefined || self.ebBlPlan.placeOfIssueId === '') {
            self.ebBlPlan.placeOfIssueId = self.ebOrder.polId;
            self.ebBlPlan.placeOfIssueCode = self.ebOrder.polCode;
            self.ebBlPlan.placeOfIssueName = self.ebOrder.polName;
          }
          if (self.ebBlPlan.ctnNum === undefined || self.ebBlPlan.ctnNum === '') {
            self.ebBlPlan.ctnNum = self.ebOrder.ctnNum;
          }
          if (self.ebBlPlan.blPodName === undefined || self.ebBlPlan.blPodName === '') {
            self.ebBlPlan.blPodName = self.ebOrder.podName;
          }
          if (self.ebBlPlan.blPorName === undefined || self.ebBlPlan.blPorName === '') {
            self.ebBlPlan.blPorName = self.ebOrder.porName;
          }
          if (self.ebBlPlan.blPolName === undefined || self.ebBlPlan.blPolName === '') {
            self.ebBlPlan.blPolName = self.ebOrder.polName;
          }
          if (self.ebBlPlan.blPotName === undefined || self.ebBlPlan.blPotName === '') {
            self.ebBlPlan.blPotName = self.ebOrder.potName;
          }
          if (self.ebBlPlan.blPlaceOfDeliveryName === undefined || self.ebBlPlan.blPlaceOfDeliveryName === '') {
            self.ebBlPlan.blPlaceOfDeliveryName = self.ebOrder.placeOfDeliveryName;
          }
          if(res.records.ebCtns){
            res.records.ebCtns.forEach(function (x) {
              self.ebBlPlanCtns.forEach(function (item) {
                if (item.ebCtnId === x.ebCtnId) {
                  item.ctnNo = x.ctnNo;
                  item.sealNo = x.sealNo;
                  item.ctnSizeType = x.ctnSizeType;
                  item.ctnCompanyName = x.ctnCompanyName;
                  item.ctnCompanyCode = x.ctnCompanyCode;
                  item.isSoc = x.isSoc;
                  item.fclLclFlag = x.fclLclFlag;
                  if(!item.ebBlPlanCtnCargo){
                    item.ebBlPlanCtnCargo = []
                  }else{
                    item.ebBlPlanCtnCargo.forEach(i => {
                      i.ctnNo = x.ctnNo;
                    })
                  }
                }
              });
            });
          }
          if (res.records.ebBlPlan && res.records.ebBlPlan.ebBlPlanCtn && res.records.ebBlPlan.ebBlPlanCtn[0] !== undefined) {
            self.ebCtns = res.records.ebBlPlan.ebBlPlanCtn[0];
            if(res.records.ebBlPlan.ebBlPlanCtn[0].ebBlPlanCtnCargo){
              self.currentebBlPlanCtnCargo = res.records.ebBlPlan.ebBlPlanCtn[0].ebBlPlanCtnCargo[0];
            }
          }
          self.preAmsSendMode = self.ebBlPlan.amsSendMode;
          self.ebBlPlan.noOfOriginal = res.records.noOfOriginal === undefined ? res.records.noOfOriginal : res.records.noOfOriginal.toString();
          self.ebBlPlan.noOfCopy = res.records.noOfCopy === undefined ? res.records.noOfCopy : res.records.noOfCopy.toString();
          self.ebBlPlan.issueMode = res.records.issueMode;
          if (res.records.ebBlPlan && res.records.ebBlPlan.issueMode !== "" &&
          res.records.ebBlPlan.issueMode !== null &&
          res.records.ebBlPlan.issueMode !== undefined) {
            self.ebBlPlan.issueMode = res.records.ebBlPlan.issueMode;
          }
          self.ebCtnRequests = res.records.ebCtnRequests;
          self.ebCtnRequestDetails = res.records.ebBlPlanCtns;
          if (
            !self.ebBlPlan.ebBlPlanId &&
            self.ebOrder.ebCargos !== null &&
            self.ebOrder.ebCargos !== undefined &&
            self.ebOrder.ebCargos.length > 0
          ) {
            let target = self.ebOrder.ebCargos.find((item) => {
              return item.totalFlag === "M";
            });
            self.ebBlPlan.marks = target.marks;
            self.ebBlPlan.commodity = target.cargoDescription;
            self.ebBlPlan.noOfPackages = target.noOfPackage;
            self.ebBlPlan.packageTypeName = target.packageTypeName;
            self.ebBlPlan.packageTypeCode = target.packageTypeCode;
            self.ebBlPlan.grossWeight = target.grossWeight;
            self.ebBlPlan.cube = target.cube;
            self.ebBlPlan.netWeight = target.netWeight;
            self.ebBlPlan.hsCode = target.hsCode;
          }
          let checkedArr = [];
          if (
            self.ebOrder.ebServiceItems &&
            self.ebOrder.ebServiceItems.length > 0
          ) {
            self.ebOrder.ebServiceItems.forEach((el, index) => {
              checkedArr.push(el.serviceCode + "/" + el.serviceName);
            });
          }
          if (res.records.ebBlPlan && res.records.ebBlPlan.ebBlPlanId) {
            if (res.records.ebBlPlan.ebBlPlanParty) {
              res.records.ebBlPlan.ebBlPlanParty.forEach((el) => {
                self.ebParty["ebParty" + el.partyType] = el;
                self.ebParty["ebParty" + el.partyType].ebBlPlanPartyId = el.ebBlPlanPartyId;
              });
            }
          } else {
            if (res.records.ebPartys.length > 0) {
              res.records.ebPartys.forEach((el) => {
                self.ebParty["ebParty" + el.partyType] = el;
              });
            }
          }
          if (res.records.ebCargos.length > 1) {
            res.records.ebCargos.forEach((el) => {
              if (el.totalFlag === "M") {
                //self.ebCargo.ebCargoM = el;
                //为了应对对象赋值导致的对象劫持，使输入框不能输入或者延迟输入
                self.ebCargo.ebCargoM = JSON.parse(JSON.stringify(el));
              } else {
                self.ebCargo.ebCargoD.push(el);
              }
            });
          }
          self.ebServiceItemList = checkedArr;
          self.ebServiceItemsBuffer = res.records.ebServiceItems;
          if (self.ebOrderType === "copy") {
            self.ebOrderType = null;
          }

          //根据船公司和分公司查询拓展信息
          if (self.ebOrder.carrierId && self.ebOrder.settleOffice) {
            let params = {
              carrierId: this.ebOrder.carrierId,
              settleOffice: this.ebOrder.settleOffice,
              businessType: "MBL", currentPage: 1,
              pageSize: 100
            };
            queryMdCarrierInfo(params).then(result => {
              if (result.records.records.length === 0) {
                self.carrierExpand = []
                return
              }
              let dicParams = []
              self.bookingForm = {}
              result.records.records.forEach((el) => {
                if (el.fieldCode !== null &&
                  el.fieldCode !== "" &&
                  el.fieldCode !== undefined) {
                  if (self.carrierExpand.length !== 0) {
                    let isCarrierExpandPushed = self.carrierExpand.find(item => item.fieldCode === el.fieldCode)
                    if (isCarrierExpandPushed) return
                  }
                  self.$set(self.bookingForm, el.fieldCode, null)
                  self.carrierExpand.push(el);
                  if (el.controlType === "01") {
                    dicParams.push(el.controlBindCode);
                  }
                }
              });
              self.getCarrierSelectList(dicParams.toString());
              if (self.ebBlPlan.jsonInfo !== null &&
                self.ebBlPlan.jsonInfo !== "" &&
                self.ebBlPlan.jsonInfo !== undefined) {
                self.bookingForm = JSON.parse(self.ebBlPlan.jsonInfo)
              }
              self.$forceUpdate();
            })
          }

          // //查询是否有这条提单号的数据权限
          // if(res.records.mblNo === '' ){
          //   this.ebBlPlan={
          //     approvalStatus: 'NEW',
          //     marks: '',
          //     commodity: '',
          //     noOfPackages: '',
          //     packageTypeName: '',
          //     grossWeight: '',
          //     cube: '',
          //     netWeight: '',
          //     hsCode: '',
          //   };
          // }else {
          //   let queryData = {
          //     arrayNo: res.records.mblNo,
          //     currentPage: 10,
          //     pageSize: 1
          //   };
          //   getBillManage(queryData).then((res) => {
          //     if (res.success) {
          //       if( res.records.totalRecord<1){
          //         /*this.ebBlPlan.approvalStatus = "NEW";
          //         this.ebBlPlan.marks = "";
          //         this.ebBlPlan.commodity = "";
          //         this.ebBlPlan.noOfPackages = "";
          //         this.ebBlPlan.packageTypeName = "";
          //         this.ebBlPlan.grossWeight = "";
          //         this.ebBlPlan.cube = "";
          //         this.ebBlPlan.netWeight = "";
          //         this.ebBlPlan.hsCode = "";*/
          //         this.ebBlPlan = {
          //           approvalStatus: 'NEW',
          //           marks: '',
          //           commodity: '',
          //           noOfPackages: '',
          //           packageTypeName: '',
          //           grossWeight: '',
          //           cube: '',
          //           netWeight: '',
          //           hsCode: '',
          //         };
          //       }
          //     }
          //   });
          // }
          //控制按钮因为异步问题出现的连续点击报错
          self.loading = false;
        }
        self.loading = false;
      });
    },
    confirmChange(){
      let self = this;
      if(self.ebBlPlan.scacCode || self.ebBlPlan.aciCode){
        self.$confirm('提示',
          {
            title: '提示',
            message: '切换AMS/ACI发送方式会清空SCAC CODE和ACI/EMF CODE，是否确认切换？',
            confirmButtonText: '确定',
            cancelButtonText: '取消',

          }).then(()=>{
          self.ebBlPlan.scacCode = '';
          self.ebBlPlan.aciCode = '';
          self.preAmsSendMode = self.ebBlPlan.amsSendMode;
          self.$refs["amsSendMode"].blur();
        }).catch(()=>{
          self.ebBlPlan.amsSendMode = self.preAmsSendMode;
          self.$refs["amsSendMode"].blur();
        })
      }
    },
    hsaChange() {
      let self = this;
      let amsSendMode = self.ebBlPlan.amsSendMode;
      if (amsSendMode === "CS") {
        let houseBlNo = self.ebBlPlan.houseBlNo;
        let scacCode = self.ebBlPlan.scacCode;
        let aciCode = self.ebBlPlan.aciCode;
        let newRules = JSON.parse(JSON.stringify(this.billEditFormRules));
        if ((houseBlNo !== "" && houseBlNo !== null && houseBlNo !== undefined)
          || (scacCode !== "" && scacCode !== null && scacCode !== undefined)
          || (aciCode !== "" && aciCode !== null && aciCode !== undefined)) {
          delete newRules['houseBlNo']
          delete newRules['scacCode']
          delete newRules['aciCode']
        } else {
          newRules['houseBlNo'] = [{required: true, message: '请输入', trigger: 'blur'},]
         /* newRules['scacCode'] = [{required: true, message: '请输入', trigger: 'blur'},]
          newRules['aciCode'] = [{required: true, message: '请输入', trigger: 'blur'},]*/
        }
        this.billEditFormRules = newRules;
        setTimeout(() => {
          this.$refs.billEditFormRef.clearValidate();
          this.$forceUpdate();
        });
      }
    },
    onChangeplaceOfDest(value, selectedRows) {
      this.ebBlPlan.placeOfDestId = selectedRows.mdPortId;
      this.ebBlPlan.placeOfDestCode = selectedRows.portCode;
      this.ebBlPlan.blPlaceOfDestName = selectedRows.portNameEn;
    },
    onChangeplaceOfDelivery(value, selectedRows) {
      this.ebOrder.placeOfDeliveryId = selectedRows.mdPortId;
      this.ebOrder.placeOfDeliveryCode = selectedRows.portCode;
      this.ebBlPlan.blPlaceOfDeliveryName = selectedRows.portNameEn;
    },
    changeHblPaymentPlace(value, selectedRows) {
      this.ebOrder.hblPaymentPlace = selectedRows.mdPortId;
      this.ebOrder.hblPaymentPlaceId = selectedRows.portCode;
    },

    // 场内场外求和
    sumFreeDaysChange() {
      if (this.ebOrder.freeStorage && this.ebOrder.freeOfDetention) {
        this.ebOrder.freeStorage = parseInt(this.ebOrder.freeStorage);
        this.ebOrder.freeOfDetention = parseInt(this.ebOrder.freeOfDetention);
        this.ebOrder.freeDays =
          this.ebOrder.freeStorage + this.ebOrder.freeOfDetention;
        this.$forceUpdate();
      } else if (this.ebOrder.freeStorage) {
        this.ebOrder.freeStorage = parseInt(this.ebOrder.freeStorage);
        this.ebOrder.freeDays = this.ebOrder.freeStorage;
      } else if (this.ebOrder.freeOfDetention) {
        this.ebOrder.freeOfDetention = parseInt(this.ebOrder.freeOfDetention);
        this.ebOrder.freeDays = this.ebOrder.freeOfDetention;
      }
    },
    // 前端表单数据校验
    validateBillEditInfo(submitType) {
      this.$refs.billEditFormRef.validate(values => {
        if (values) {
          this.saveAndSubmit(submitType);
        }
      })
    },
    ctnSizeTypeChange(value, selectedRows) {
      let self = this;
      let ctnSizeTypeMapAll = '';
      let ctnSizeTypeNum = self.ctnSizeTypeMap.get(selectedRows.containerType)
      if (ctnSizeTypeNum === undefined) {
        self.ctnSizeTypeMap.set(selectedRows.containerType, 1)
      } else if (ctnSizeTypeNum >= 1) {
        ctnSizeTypeNum++;
        self.ctnSizeTypeMap.set(selectedRows.containerType, ctnSizeTypeNum)
      }
      if (self.ebBlPlan.ctnNum === undefined) {
        ctnSizeTypeMapAll = '';
      } else if (self.ebBlPlan.ctnNum !== undefined) {
        ctnSizeTypeMapAll = self.ebBlPlan.ctnNum;
      } else {
        self.$coreMethods.message("warning", "箱型箱量汇总有误!");
      }
      ctnSizeTypeMapAll = '';
      self.ctnSizeTypeMap.forEach((value, key) => {
        ctnSizeTypeMapAll += (value + '*' + key + ';')
      })
      self.ebBlPlan.ctnNum = ctnSizeTypeMapAll;
      self.$forceUpdate()
    },
    gatherCtnNum() {
      let self = this;
      let ctnSizeTypeMapAll = '';
      console.info(self.ebBlPlanCtns);
      self.ctnSizeTypeMap.forEach((value, key) => {
        if (value > 0) {
          ctnSizeTypeMapAll += (key + '*' + value + ';')
        }
      })
      console.log(self.ctnSizeTypeMap)
      self.ebBlPlan.ctnNum = ctnSizeTypeMapAll
    },
    confirmAlert(confirmText){
      let newDatas = [];
      let h = this.$createElement;
      confirmText.forEach(msg => {
        let no = confirmText.indexOf(msg)+1;
        newDatas.push(h('p', null, no+" . "+confirmText[no-1]))
      })
      this.$confirm(
        '提示',
        {
          title: '提示',
          message: h('div', null, newDatas),
          showCancelButton: false,
          confirmButtonText: '确定',
          cancelButtonText: '取消',

        }
      ).then(() => {

      })
    },
    open(submitType, self) {
      self.ebBlPlan.jsonInfo = JSON.stringify(self.bookingForm);
      /*这里赋值是什么意义
      self.ebOrder.ebCtns.forEach(ebBlPlanItem => {
        self.ebBlPlanCtns.forEach(item => {
          if (ebBlPlanItem.ebCtnId === item.ebCtnId) {
            ebBlPlanItem.ctnNo = item.ctnNo;
            ebBlPlanItem.sealNo = item.sealNo;
            ebBlPlanItem.ctnSizeType = item.ctnSizeType;
            ebBlPlanItem.ctnCompanyName = item.ctnCompanyName;
            ebBlPlanItem.ctnCompanyCode = item.ctnCompanyCode;
            ebBlPlanItem.isSoc = item.isSoc;
            ebBlPlanItem.fclLclFlag = item.fclLclFlag;
          }
        })
      })*/
      let data = {
        ebOrderDTO: self.ebOrder,
        ebBlPlan: self.ebBlPlan,
        dataType: "MBL"
      };
      if (submitType === 1) {
        self.loading = false;
        return;
      }
      if (self.ebOrder && self.ebOrder.ebOrderId) {
        data.ebOrderDTO.rowStatus = 2;
        if (data.ebBlPlan.ebBlPlanId) {
          data.ebBlPlan.rowStatus = 16;
        } else {
          data.ebBlPlan.rowStatus = 4;
        }
        let ebUserId = JSON.parse(localStorage.getItem('userInfo')).userId;
        let ebUserName = JSON.parse(localStorage.getItem('userInfo')).userNameCn;
        data.ebBlPlan.ebOrderId = self.ebOrder.ebOrderId;
        data.ebBlPlan.ebUserId = ebUserId;
        data.ebBlPlan.ebUserName = ebUserName;
        data.ebBlPlan.ebBlPlanCtn = self.ebBlPlanCtns;
        data.ebBlPlan.ctnNum = self.ebOrder.ctnNum;
        data.ebBlPlan.isHazard = self.ebCargo.ebCargoM.isHazard;
        data.ebBlPlan.isReefer = self.ebCargo.ebCargoM.isReefer;
        data.ebBlPlan.isBulkyCargo = self.ebCargo.ebCargoM.isBulkyCargo;
        data.ebBlPlan.ebBlPlanCtn.forEach(function (item) {
          item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
          item.settleOffice = data.ebOrderDTO.settleOffice;
          delete item.recordVersion;
          if (item.ebBlPlanCtnId) {
            item.rowStatus = 16
          } else {
            item.rowStatus = 4;
          }
          item.ebOrderId = self.ebOrder.ebOrderId;
          item.ebUserId = ebUserId;
          item.ebUserName = ebUserName;
          if(item.ebBlPlanCtnCargo){
            item.ebBlPlanCtnCargo.forEach(function (x) {
              x.ebUserId = ebUserId;
              x.ebUserName = ebUserName;
              x.ebBlPlanId = data.ebBlPlan.ebBlPlanId;
              if (x.ebBlPlanCtnCargoId) {
                x.rowStatus = 16;
              } else {
                x.rowStatus = 4;
              }
            });
          }
          item.ebCtn = {};
          item.ebCtn.ebCtnId = item.ebCtnId !== undefined ? item.ebCtnId : null;
          item.ebCtn.ebOrderId = item.ebOrderId !== undefined ? item.ebOrderId : null;
          item.ebCtn.ctnNo = item.ctnNo !== undefined ? item.ctnNo : null;
          item.ebCtn.sealNo = item.sealNo !== undefined ? item.sealNo : null;
          item.ebCtn.ctnSizeType = item.ctnSizeType !== undefined ? item.ctnSizeType : null;
          item.ebCtn.ctnCompanyName = item.ctnCompanyName !== undefined ? item.ctnCompanyName : null;
          item.ebCtn.ctnCompanyCode = item.ctnCompanyCode !== undefined ? item.ctnCompanyCode : null;
          item.ebCtn.isSoc = item.isSoc !== undefined ? item.isSoc : null;
          item.ebCtn.fclLclFlag = item.fclLclFlag !== undefined ? item.fclLclFlag : null;
          if (item.ebCtn.ebCtnId) {
            item.ebCtn.rowStatus = 16
          } else {
            item.ebCtn.rowStatus = 4;
          }
        });
        delete data.ebOrderDTO.ebPartys;
        data.ebBlPlan.ebBlPlanParty = [];
        if (self.ebParty) {
          Object.entries(self.ebParty).forEach(function (item) {
            item[1].ebBlPlanId = data.ebBlPlan.ebBlPlanId;
            item[1].ebOrderId = data.ebBlPlan.ebOrderId;
            item[1].ebUserId = ebUserId;
            item[1].ebUserName = ebUserName;
            item[1].settleOfficeName = data.ebOrderDTO.settleOfficeName;
            item[1].settleOffice = data.ebOrderDTO.settleOffice;
            if (item[1].ebBlPlanPartyId) {
              item[1].rowStatus = 16;
            } else {
              item[1].rowStatus = 4;
            }
            delete item[1].ebPartyId;
            delete item[1].recordVersion;
            data.ebBlPlan.ebBlPlanParty.push(item[1]);
          })
        }
      }
      if(data.ebOrderDTO.ebCargos) {
        data.ebOrderDTO.ebCargos.forEach(item => {
          item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
          item.settleOffice = data.ebOrderDTO.settleOffice;
        });
      }
      if(data.ebOrderDTO.ebCtnRequests) {
        data.ebOrderDTO.ebCtnRequests.forEach(item => {
          item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
          item.settleOffice = data.ebOrderDTO.settleOffice;
        });
      }
      if(data.ebOrderDTO.ebServiceItems) {
        data.ebOrderDTO.ebServiceItems.forEach(item => {
          item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
          item.settleOffice = data.ebOrderDTO.settleOffice;
        });
      }
      if(data.ebOrderDTO.ebCtns){
        data.ebOrderDTO.ebCtns.forEach(item => {
          item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
          item.settleOffice = data.ebOrderDTO.settleOffice;
        });
      }
      if(data.ebOrderDTO.ebBlPlan) {
        if(data.ebOrderDTO.ebBlPlan.ebBlPlanParty) {
          data.ebOrderDTO.ebBlPlan.ebBlPlanParty.forEach(item => {
            item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
            item.settleOffice = data.ebOrderDTO.settleOffice;
          });
        }
        if(data.ebOrderDTO.ebBlPlan.ebBlPlanCtn) {
          data.ebOrderDTO.ebBlPlan.ebBlPlanCtn.forEach(item => {
            item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
            item.settleOffice = data.ebOrderDTO.settleOffice;
          });
        }
      }
      //所有校验的合集
      let strMsg = [];
      //校验箱货信息中的箱号，在网服实装箱中是否存在
      let result = false;
      if(data.ebOrderDTO.ebCtns){
        self.ebBlPlanCtns.forEach(item1 =>{
          data.ebOrderDTO.ebCtns.forEach(item2 =>{
            if(item1.ctnNo === item2.ctnNo ){
              if(item1.ctnSizeType !== item2.ctnSizeType || item1.sealNo.toString() !== item2.sealNo){
                result = true;
              }
            }
          });
        });
      }
      // else {
      //   data.ebOrderDTO.ebCtns = {}
      //   self.ebBlPlanCtns.forEach(item1 =>{
      //     data.ebOrderDTO.ebCtns.push(item1.ebCtn)
      //   });
      // }
      if(result){
        let str = "校验箱货信息中的箱号，与网服实装箱中数据不一致，无法提交！";
        strMsg.push(str);
        //self.$coreMethods.message("warning", "校验箱货信息中的箱号，与网服实装箱中数据不一致，无法提交！");
        //self.loading = false;
        //return;
      }
      if (self.ebBlPlan.amsSendMode === 'CS') {
        if (self.ebBlPlan.houseBlNo == "" && self.ebBlPlan.scacCode == "" && self.ebBlPlan.aciCode == "") {
          let str = "HBL NO 不能为空！";
          strMsg.push(str);
        }
      }
      //判断实装箱汇总的箱型箱量和预配箱数据是否一致
      debugger
      let boxs1 = [];
      if(self.ebOrder.ctnNum !== ""
        || self.ebOrder.ctnNum !== null
        || self.ebOrder.ctnNum !== undefined ){
        boxs1= self.ebOrder.ctnNum.split("+");
      }
      let boxs2 = []
      self.ebBlPlanCtns.forEach(item=>{boxs2.push(item)});
      let result1 = false;
      if(boxs1.length>0 ){
        let box1indexNum = [];
        boxs1.forEach(item =>{
          let arr = item.split("*")
          let ctnSizeType = arr[1];
          let ctnNum = Number(arr[0]);
          let indexNum = [];
          if(boxs2.length>0){
            boxs2.forEach(item1=> {
              if(ctnSizeType === item1.ctnSizeType){
                ctnNum--;
                indexNum.push(boxs2.indexOf(item1));
              }
            });
            if(ctnNum !== 0){
              result1 = true;
            }
            let i ;
            for (i = indexNum.length-1; i >= 0; i--) {
              boxs2.splice(indexNum[i], 1);
            }
          }else{
            result1 = true;
          }
          let index = boxs1.indexOf(item);
          box1indexNum.push(index);
        });
        for (let i = box1indexNum.length - 1; i >= 0; i--) {
          boxs1.splice(box1indexNum[i], 1);
        }
        if(boxs1.length>0 || boxs2.length>0){
          result1 = true;
        }
      }else{
        if(boxs2.length>0){
          result1 = true;
        }
      }
      if(result1){
        let str = "箱货信息的箱型箱量和预配箱数据不一致，无法提交保存！";
        strMsg.push(str);
        /*self.$coreMethods.message("warning", "箱货信息的箱型箱量和预配箱数据不一致，无法提交！");
        self.loading = false;
        return;*/
      }
      if (submitType === 2) {
        if(strMsg.length>0){
          self.loading = false;
          self.confirmAlert(strMsg);
          return;
        }

        //暂存草稿
        publicSave(data)
          .then((res) => {
            if (res.success) {
              self.ebBlPlan = JSON.parse(JSON.stringify(res.records.ebBlPlan))
              self.getBillEditData(res.records.ebOrderId);
              self.$coreMethods.message("success", "操作成功");
              self.loading = false;
            }
          }).catch((res) => {
          self.loading = false;
          self.$coreMethods.message("error", "操作失败");
        });
      } else if (submitType === 3) {
        if(data.ebBlPlan.amsSendMode === 'SS'){
          let result = false;
          data.ebBlPlan.ebBlPlanParty.forEach(item =>{
            if(item.partyType === "RSH" || item.partyType === "RCN" ||item.partyType === "RNT"){
              if(item.partyDescription === "" || item.partyDescription === null || item.partyDescription === undefined){
                result = true;
              }
            }
          });
          if(result){
            let str = "船司代发（HBL）需要填写真实收发通!";
            strMsg.push(str);
           /* self.loading = false;
            self.$confirm('船司代发（HBL）需要填写真实收发通!', '提示', {
              showCancelButton: false,
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
            //self.$coreMethods.message("warning", "船司代发（HBL）需要填写真实收发通!");
            return*/
          }
        }
        if(data.ebBlPlan.amsSendMode === 'CS'){
          if((data.ebBlPlan.aciCode === '' || data.ebBlPlan.aciCode === null || data.ebBlPlan.aciCode === undefined)
            &&(data.ebBlPlan.scacCode === '' || data.ebBlPlan.scacCode === null || data.ebBlPlan.scacCode === undefined)) {
            let str = "SCAC CODE和ACI/EMF CODE必须维护一个!";
            strMsg.push(str);
            /*self.loading = false;
            self.$confirm('SCAC CODE和ACI/EMF CODE必须维护一个!', '提示', {
              showCancelButton: false,
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })*/
            self.loading = false;
            self.$coreMethods.message("warning", "SCAC CODE/ACI/EMF CODE必须维护一个!");
            return
          }
          if((data.ebBlPlan.aciCode && data.ebBlPlan.aciCode.length>4)
            ||(data.ebBlPlan.scacCode && data.ebBlPlan.scacCode.length>4)){
            let str = "SCAC CODE和ACI/EMF CODE只能维护四位字符!";
            strMsg.push(str);
           /* self.loading = false;
            self.$confirm('SCAC CODE和ACI/EMF CODE只能维护四位字符!', '提示', {
              showCancelButton: false,
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            return*/
          }
        }
        if (data.ebOrderDTO.ebOrderStatus !== 'BKCONFIRM') {
          let str = "订单没有订舱成功，无法提交!";
          strMsg.push(str);
          /*self.loading = false;
          self.$coreMethods.message("warning", "订单没有订舱成功，无法提交!");
          return*/
        }
        if (data.ebBlPlan.ebBlPlanCtn.length < 1) {
          let str = "没有箱货信息，无法提交！";
          strMsg.push(str);
          /*self.loading = false;
          self.$coreMethods.message("warning", "没有箱货信息，无法提交");
          return*/
        }
        // //判断实装箱汇总的箱型箱量和预配箱数据是否一致
        // let boxs1 = self.ebOrder.ctnNum.split("+");
        // if(self.ebOrder.ctnNum === ""
        //   || self.ebOrder.ctnNum === null
        //   || self.ebOrder.ctnNum === undefined ){
        //   boxs1= [];
        // }
        // let boxs2 = []
        // self.ebBlPlanCtns.forEach(item=>{boxs2.push(item)});
        // let result1 = false;
        // if(boxs1.length>0 ){
        //   let box1indexNum = [];
        //   boxs1.forEach(item =>{
        //     let arr = item.split("*")
        //     let ctnSizeType = arr[1];
        //     let ctnNum = Number(arr[0]);
        //     let indexNum = [];
        //     if(boxs2.length>0){
        //       boxs2.forEach(item1=> {
        //         if(ctnSizeType === item1.ctnSizeType){
        //           ctnNum--;
        //           indexNum.push(boxs2.indexOf(item1));
        //         }
        //       });
        //       if(ctnNum !== 0){
        //         result1 = true;
        //       }
        //       let i ;
        //       for (i = indexNum.length-1; i >= 0; i--) {
        //         boxs2.splice(indexNum[i], 1);
        //       }
        //     }else{
        //       result1 = true;
        //     }
        //     let index = boxs1.indexOf(item);
        //     box1indexNum.push(index);
        //   });
        //   for (let i = box1indexNum.length - 1; i >= 0; i--) {
        //     boxs1.splice(box1indexNum[i], 1);
        //   }
        //   if(boxs1.length>0 || boxs2.length>0){
        //     result1 = true;
        //   }
        // }else{
        //   if(boxs2.length>0){
        //     result1 = true;
        //   }
        // }
        // if(result1){
        //   let str = "箱货信息的箱型箱量和预配箱数据不一致，无法提交！";
        //   strMsg.push(str);
        //   /*self.$coreMethods.message("warning", "箱货信息的箱型箱量和预配箱数据不一致，无法提交！");
        //   self.loading = false;
        //   return;*/
        // }
        if(strMsg.length>0){
          self.loading = false;
          self.confirmAlert(strMsg);
          return;
        }
        if(data.ebBlPlan.houseBlNo === undefined){
          data.ebBlPlan.houseBlNo = "";
        }
        if(data.ebBlPlan.aciCode === undefined){
          data.ebBlPlan.aciCode = "";
        }
        if(data.ebBlPlan.scacCode === undefined){
          data.ebBlPlan.scacCode = "";
        }
        data.type = "web";
        if (self.ebServiceItemsBuffer) {
          self.ebServiceItemsBuffer.forEach(item =>{
            if (item.serviceCode === 'HBL') {
              data.ebOrderDTO.dataType = 'HBL';
              data.dataType = 'HBL';
            }
          })
        }
        if(self.ebOrder.mblNo && data.dataType === "HBL"){
          data.ebOrderDTO.mblNo = self.ebOrder.mblNo
        }
        //提交
        saveAndSub(data)
          .then((res) => {
            if (res.success) {
              self.getBillEditData(res.records.ebOrderId);
              self.loading = false;
              self.$coreMethods.message("success", "操作成功");
              self.$store.dispatch("tagsView/delView", self.$route).then(() => {
                self.$nextTick(() => {
                  self.$router.push({
                    name: "ladingbillManagement",
                    params: {
                      fromWhere: "afterSubmit"
                    }
                  });
                });
              });
            }
          }).catch((res) => {
          self.loading = false;
          self.$coreMethods.message("error", "操作失败");
        });
      }
    },
    saveBillEditInfo(submitType) {
      let self = this;
      self.$refs.billEditFormRef.validate(billEditValid => {
        self.$refs.ebCargoRef.ebCargoValidate(ebCargoValid => {
          self.$refs.ebPartyRef.ebPartyValidate(ebPartyValid => {
            self.$refs.billBoxInfoTableRef.hotInstance.validateColumns([1,2,3,4,5,6,7,11],(billBoxInfoTableRef) => {
              self.$refs.billCargoInfoTableRef.hotInstance.validateColumns([1,2,4,5,6,7,8],(billCargoInfoTableRef) => {
                  if (billEditValid && ebCargoValid && ebPartyValid && billBoxInfoTableRef && billCargoInfoTableRef) {
                  self.loading = true;
                  let ctnMsg = [];
                  let count = 1;
                  if(self.ebBlPlanCtns){
                    self.ebBlPlanCtns.forEach(item => {
                      if(item.ebBlPlanCtnCargo){
                        let rowIndex = 0;
                        let ctnCargoMsg = [];
                        item.ebBlPlanCtnCargo.forEach(x => {
                          rowIndex++;
                          if(x.hsCode === "" || x.hsCode === null || x.hsCode === undefined){
                            ctnCargoMsg.push(" 第" + rowIndex + "行HS CODE不能为空");
                          }
                          if(x.cargoDescription === "" || x.cargoDescription === null || x.cargoDescription === undefined){
                            ctnCargoMsg.push(" 第" + rowIndex + "行货物描述不能为空");
                          }
                          if(x.noOfPackage === "" || x.noOfPackage === null || x.noOfPackage === undefined){
                            ctnCargoMsg.push(" 第" + rowIndex + "行件数不能为空");
                          }
                          if(x.packageTypeName === "" || x.packageTypeName === null || x.packageTypeName === undefined){
                            ctnCargoMsg.push(" 第" + rowIndex + "行包装单位不能为空");
                          }
                          if(x.grossWeight === "" || x.grossWeight === null || x.grossWeight === undefined){
                            ctnCargoMsg.push(" 第" + rowIndex + "行毛重不能为空");
                          }
                          if(x.cube === "" || x.cube === null || x.cube === undefined){
                            ctnCargoMsg.push(" 第" + rowIndex + "行体积不能为空");
                          }
                        });
                        if(ctnCargoMsg.length > 0){
                          ctnMsg.push(count+".箱号【" + item.ctnNo + "】下货物信息中:");
                          ctnCargoMsg.forEach(msg =>{
                            ctnMsg.push(msg);
                          })
                          count++;
                        }
                      }
                    });
                  }
                  if(ctnMsg.length > 0){
                    // self.$coreMethods.message( "warning",ctnMsg, true);
                    self.msgAlert("",ctnMsg);
                    self.loading = false;
                    return;
                  }
                  let ebSum = self.ebBlPlan.noOfPackages + self.ebBlPlan.grossWeight + self.ebBlPlan.cube;
                  let ebCtnsSum = 0;
                  let ctnNoSet = new Set();
                  if(self.ebBlPlan.amsSendMode === "FS"){
                    if(self.ebParty.ebPartyRSH && (self.ebParty.ebPartyRSH.partyDescription === undefined || self.ebParty.ebPartyRSH.partyDescription === "")
                      || self.ebParty.ebPartyRCN && (self.ebParty.ebPartyRCN.partyDescription === undefined || self.ebParty.ebPartyRCN.partyDescription === "")
                      || self.ebParty.ebPartyRNT && (self.ebParty.ebPartyRNT.partyDescription === undefined || self.ebParty.ebPartyRNT.partyDescription === "")){
                      self.$coreMethods.message( "warning","CTS代发，需要填写真实收发通");
                      self.loading = false;
                      return;
                    }
                  }
                  let shMsg = self.vaildStringAsciiCodeWithRowMbl(self.ebParty.ebPartySH.partyDescription);
                  let cnMsg = self.vaildStringAsciiCodeWithRowMbl(self.ebParty.ebPartyCN.partyDescription);
                  let ntMsg = self.vaildStringAsciiCodeWithRowMbl(self.ebParty.ebPartyNT.partyDescription);
                  if(shMsg && shMsg.length > 0){
                    // let msg = shMsg.join("</br>");
                    // self.$coreMethods.message( "warning","发货人" +  msg, true);
                    self.msgAlert("收发通信息中，发货人：",shMsg)
                    self.loading = false;
                    return;
                  }
                  if(cnMsg && cnMsg.length > 0){
                    // let msg = cnMsg.join("</br>");
                    // self.$coreMethods.message( "warning","收货人" +  msg, true);
                    self.msgAlert("收发通信息中，收货人：",cnMsg)
                    self.loading = false;
                    return;
                  }
                  if(ntMsg && ntMsg.length > 0){
                    // let msg = ntMsg.join("</br>");
                    // self.$coreMethods.message( "warning","通知人" +  msg, true);
                    self.msgAlert("收发通信息中，通知人：",ntMsg)
                    self.loading = false;
                    return;
                  }
                  let marksMsg = self.vaildStringAsciiCodeWithRowMbl(self.ebBlPlan.marks);
                  let cargoNameMsg = self.vaildStringAsciiCodeWithRowMbl(self.ebBlPlan.commodity);
                  if(marksMsg && marksMsg.length > 0){
                    // let msg = marksMsg.join("</br>");
                    // self.$coreMethods.message( "warning","唛头" +  msg, true);
                    self.msgAlert("唛头信息中：",marksMsg)
                    self.loading = false;
                    return;
                  }
                  if(cargoNameMsg && cargoNameMsg.length > 0){
                    // let msg = cargoNameMsg.join("</br>");
                    // self.$coreMethods.message( "warning","货物描述" +  msg, true);
                    self.msgAlert("货物描述中：",cargoNameMsg)
                    self.loading = false;
                    return;
                  }
                  self.ebBlPlanCtns.forEach(item => {
                    ctnNoSet.add(item.ctnNo);
                    ebCtnsSum += parseFloat(item.noOfPackage) + parseFloat(item.grossWeight) + parseFloat(item.cube);
                  })
                  if (ctnNoSet.size !== self.ebBlPlanCtns.length) {
                    self.loading = false;
                    // self.$coreMethods.message("warning", "箱号不能重复，请修改！");
                    self.msgAlert("箱号不能重复，请修改！",[]);
                    return;
                  }
                  let ctnNoResult = "";
                  let ctnNoSet2 = new Set();
                  self.ebBlPlanCtns.forEach(item => {
                      if(item.isSoc !== 1){
                        ctnNoSet2.add(item.ctnNo);
                      }
                  });
                  let ctnCargoSum = 0;
                  let ctnCargoMsg = "";
                  self.ebBlPlanCtns.forEach(item =>{
                    if(!(item.ebBlPlanCtnCargo && item.ebBlPlanCtnCargo.length > 0)){
                      ctnCargoMsg = ctnCargoMsg + item.ctnNo + "、";
                      ctnCargoSum++;
                    }
                  });
                  if(ctnCargoMsg.length >0 && ctnCargoSum !== self.ebBlPlanCtns.length){
                    // this.$coreMethods.message( "warning","箱号:"+ctnCargoMsg+"没有维护货物信息");
                    self.msgAlert("箱号:"+ctnCargoMsg+"没有维护货物信息",[]);
                    self.loading = false;
                    return;
                  }
                  ctnNoSet.forEach(item => {
                    if(item){
                      ctnNoResult = self.validContainerNo(item,ctnNoResult);
                    }else {
                      // this.$coreMethods.message( "warning","箱号不能为空！");
                      self.msgAlert("箱号不能为空！",[]);
                      self.submitType = 1;
                      self.loading = false;
                      return;
                    }
                  })
                  if (ebSum !== ebCtnsSum) {
                    self.$confirm('箱货信息中的件重尺和货物小计中的件重尺不一致，是否继续？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    }).then(() => {
                      if(ctnNoResult !== ""){
                        self.$confirm("箱号" + ctnNoResult + "不符合箱号规范，是否继续保存！", '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning'
                        }).then(() => {
                            if(submitType === 3){
                              self.$confirm('提交后，如事后需要更改请联系华贸单证，是否提交？', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                              }).then(() => {
                                self.open(submitType, self);
                              }).catch(() => {
                                self.submitType = 1;
                                self.loading = false;
                              });
                            }else{
                              self.open(submitType, self);
                            }
                          }).catch(() => {
                          self.submitType = 1;
                          self.loading = false;
                        });
                      }else {
                        if(submitType === 3){
                          self.$confirm('提交后，如事后需要更改请联系华贸单证，是否提交？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                          }).then(() => {
                            self.open(submitType, self);
                          }).catch(() => {
                            self.submitType = 1;
                            self.loading = false;
                          });
                        }else{
                          self.open(submitType, self);
                        }
                      }
                    }).catch(() => {
                      self.submitType = 1;
                      self.loading = false;
                    });
                  } else {
                    if(ctnNoResult !== ""){
                      self.$confirm("箱号" + ctnNoResult + "不符合箱号规范，是否继续保存！", '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                      }).then(() => {
                          if(submitType === 3){
                            self.$confirm('提交后，如事后需要更改请联系华贸单证，是否提交？', '提示', {
                              confirmButtonText: '确定',
                              cancelButtonText: '取消',
                              type: 'warning'
                            }).then(() => {
                              self.open(submitType, self);
                            }).catch(() => {
                              self.submitType = 1;
                              self.loading = false;
                            });
                          }else{
                            self.open(submitType, self);
                          }
                        }).catch(() => {
                        self.submitType = 1;
                        self.loading = false;
                      });
                    }else {
                      if(submitType === 3){
                        self.$confirm('提交后，如事后需要更改请联系华贸单证，是否提交？', '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning'
                        }).then(() => {
                          self.open(submitType, self);
                        }).catch(() => {
                          self.submitType = 1;
                          self.loading = false;
                        });
                      }else{
                        self.open(submitType, self);
                      }
                    }
                  }
                } else {
                    self.loading = false;
                    if (!billEditValid) {
                      self.validateAutoFocus();
                    } else if (!ebPartyValid){
                      self.$refs.ebPartyRef.validateAutoFocus();
                    } else if (!ebCargoValid){
                      self.$refs.ebCargoRef.validateAutoFocus();
                    }
                }
              });
            });
          });
        });
      });
    },
    submitBillEditInfo(submitType) {
      return null;
    },
    msgAlert(str,tipsMsg){
      let newDatas = [];
      let h = this.$createElement;
      if(str !== "" && str !== undefined && str !== null){
        newDatas.push(h('p', null, str));
      }
      tipsMsg.forEach(msg => {
        // let no = ctnMsg.indexOf(msg)+1;
        newDatas.push(h('p', null, msg));
      })
      this.$confirm(
        '提示',
        {
          title: '提示',
          message: h('div', null, newDatas),
          showCancelButton: false,
          confirmButtonText: '确定',
          cancelButtonText: '取消',

        }
      ).then(() => {

      })
    },
    validContainerNo(containerNo, containerNos){
      if(containerNo.length == 11){
        var ctnArr = [];
        var strArr = ["10010203040506070809", "09020406081001030507", "07040801050902061003", "03080502100704010906"];
        for (var i=0; i < 4; i++) {
          if (containerNo.charAt(i).charCodeAt() > "Z".charCodeAt() || containerNo.charAt(i).charCodeAt() < "A".charCodeAt()) {
            containerNos += containerNo + ",";
            return containerNos;
          }
          var tempIndex = ((((parseFloat(containerNo.charAt(i).charCodeAt()) - parseFloat("A".charCodeAt())) % 10 ) + 1 ) * 2 ) - 2;
          ctnArr[i] = strArr[i].substring(tempIndex, tempIndex + 2);
        }
        for (var i=4; i < 11; i++) {
          if (containerNo.charAt(i).charCodeAt() > "9".charCodeAt() || containerNo.charAt(i).charCodeAt() < "0".charAt()) {
            containerNos+=containerNo+",";
            return containerNos;
          }
        }
        var r1 = (parseFloat(ctnArr[0]) + parseFloat(ctnArr[1]) + parseFloat(ctnArr[2]) + parseFloat(ctnArr[3])) % 11;
        var r2 = (5 * parseFloat(containerNo.charAt(4)) + 10 * parseFloat(containerNo.charAt(5))
          + 9 * parseFloat(containerNo.charAt(6)) + 7 * parseFloat(containerNo.charAt(7))
          + 3 * parseFloat(containerNo.charAt(8)) + 6 * parseFloat(containerNo.charAt(9))) % 11;
        var r3 = parseFloat((r1 + r2) % 11);
        if(r3 == 10) {
          r3 = 0;
        }
        if(r3 != parseFloat(containerNo.charAt(10))) {
          containerNos+=containerNo+",";
        }
      }else{
        containerNos+=containerNo+",";
      }
      return containerNos;
    },
    vaildStringAsciiCodeWithRowMbl(str) {
      var strNew = ""+str;
      var strArr = strNew.split("\n");
      if (strArr.length >0) {

        var msgArr = [];
        for (var i in strArr) {
          var str = strArr[i];
          var errorStr = str.replace(/[\x22\x23]|[\x25-\x3E]|[\x40-\x5A]|[\x5C\x5F]|[\x61-\x7A]|[\x20\x0A\x0D]/g,'');
          errorStr = errorStr.replaceAll('\\','');
          errorStr = errorStr.replaceAll('℃','');
          errorStr = errorStr.replaceAll('!','');
          errorStr = errorStr.replaceAll('|','');
          errorStr = errorStr.replaceAll('[','');
          errorStr = errorStr.replaceAll(']','');
          if(errorStr.length > 0){
            msgArr.push("第"+ parseInt(parseInt(i)+1) + "行"+"存在特殊字符【" + errorStr + "】");
          }
        }
        return msgArr;
      }
    },
    //包装联想控件修改事件
    onChangeEbBlPlanCtnsPackageType(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      let self = this;
      self.ebCtns.ebBlPlanCtnCargo[self.billCargoInfoTableSelectRowIndex].packageTypeCode =
        selectedRows.mdChargeunitCode;
      self.ebCtns.ebBlPlanCtnCargo[self.billCargoInfoTableSelectRowIndex].cnName = selectedRows.cnName;
      self.ebCtns.ebBlPlanCtnCargo[self.billCargoInfoTableSelectRowIndex].packageTypeName =
        selectedRows.enName;
      // self.$emit("getCargoInfo", this.ebCargo);
      // let PackageTypeChange = self.ebCtns.ebBlPlanCtnCargo.map(item => item.packageTypeName)
      // let pachageTypeSize = new Set(PackageTypeChange)
      // if (pachageTypeSize.size === 1) {
      //   self.ebBlPlanCtns[self.billBoxInfoTableSelectRowIndex].packageTypeCode =
      //     selectedRows.mdChargeunitCode;
      //   self.ebBlPlanCtns[self.billBoxInfoTableSelectRowIndex].cnName = selectedRows.cnName;
      //   self.ebBlPlanCtns[self.billBoxInfoTableSelectRowIndex].packageTypeName =
      //     selectedRows.enName;
      // } else if (pachageTypeSize.size > 1) {
      //   self.ebBlPlanCtns[self.billBoxInfoTableSelectRowIndex].packageTypeCode =
      //     "PKS"
      //   self.ebBlPlanCtns[self.billBoxInfoTableSelectRowIndex].cnName = "包"
      //   self.ebBlPlanCtns[self.billBoxInfoTableSelectRowIndex].packageTypeName =
      //     "PACKAGES"
      // }
    },
    //签单方式联动事件
    onChangeIssMode() {
      let self = this;
      if (self.ebBlPlan.issueMode === "O") {
        self.ebBlPlan.noOfOriginal = "3";
        self.ebBlPlan.noOfCopy = "3";
      } else {
        self.ebBlPlan.noOfOriginal = "1";
        self.ebBlPlan.noOfCopy = "0";
      }
    },
    confirmPackageType(){
      let self = this;
      if(self.ebBlPlanCtns && self.ebBlPlanCtns.length > 0 && self.ebBlPlan.packageTypeName !== self.ebBlPlanCtns[0].packageTypeName){
        self.$confirm("修改的包装更新后分箱包装将自动同步更新，是否继续修改?", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.ebBlPlanCtns.forEach((item) => {
            item.packageTypeCode = self.ebBlPlan.packageTypeCode
            item.packageTypeName = self.ebBlPlan.packageTypeName
          });
        }).catch(() => {
          self.ebBlPlan.packageTypeCode = self.ebBlPlanCtns[0].packageTypeCode
          self.ebBlPlan.packageTypeName = self.ebBlPlanCtns[0].packageTypeName
        })
      }
    },
    //获取mdCargoD的index
    getEbCtnsIndex(index) {
      console.log("mdCargoDIndex:", index);
      this.ebCtnsIndex = index;
    },
    //包装联想控件修改事件
    onChangeEbCtnsPackageType(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      let self = this;
      self.ebBlPlanCtns[self.billBoxInfoTableSelectRowIndex].packageTypeCode =
        selectedRows.mdChargeunitCode;
      self.ebBlPlanCtns[self.billBoxInfoTableSelectRowIndex].cnName = selectedRows.cnName;
      self.ebBlPlanCtns[self.billBoxInfoTableSelectRowIndex].packageTypeName =
        selectedRows.enName;
      // self.$emit("getCargoInfo", this.ebCargo);
    },
    //包装联想控件数据源
    associate_queryMethod_ebBlPlanCtns_packageType({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
          isActive4: "1",
          isPackageType5: "1",
        };
      } else {
        params = {
          mdChargeunitCode0: "%" + keyword + "%",
          enName1: "%" + keyword + "%",
          cnName2: "%" + keyword + "%",
          isDeleted3: "0",
          isActive4: "1",
          isPackageType5: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdChargeunit.cnName"],
        mainModelName: "CTS_ILPMdChargeunit",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdChargeunit.mdChargeunitCode LIKE :mdChargeunitCode0 OR CTS_ILPMdChargeunit.enName LIKE :enName1) OR CTS_ILPMdChargeunit.cnName LIKE :cnName2) AND CTS_ILPMdChargeunit.isDeleted = :isDeleted3) AND CTS_ILPMdChargeunit.isActive = :isActive4) AND CTS_ILPMdChargeunit.isPackageType = :isPackageType5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdChargeunit.mdChargeunitId",
          "CTS_ILPMdChargeunit.creatorName",
          "CTS_ILPMdChargeunit.isDeleted",
          "CTS_ILPMdChargeunit.lastModifyOfficeName",
          "CTS_ILPMdChargeunit.isChargeUnit",
          "CTS_ILPMdChargeunit.lastModifyTime",
          "CTS_ILPMdChargeunit.isContainerSize",
          "CTS_ILPMdChargeunit.creatorId",
          "CTS_ILPMdChargeunit.createOffice",
          "CTS_ILPMdChargeunit.lastModifyOffice",
          "CTS_ILPMdChargeunit.deptOfficeName",
          "CTS_ILPMdChargeunit.isPackageUnit",
          "CTS_ILPMdChargeunit.enName",
          "CTS_ILPMdChargeunit.isActive",
          "CTS_ILPMdChargeunit.recordVersion",
          "CTS_ILPMdChargeunit.relateCode",
          "CTS_ILPMdChargeunit.principalGroupCode",
          "CTS_ILPMdChargeunit.settleOfficeName",
          "CTS_ILPMdChargeunit.deptOffice",
          "CTS_ILPMdChargeunit.isPackageType",
          "CTS_ILPMdChargeunit.lastModifierId",
          "CTS_ILPMdChargeunit.cnName",
          "CTS_ILPMdChargeunit.ebMdChargeunitId",
          "CTS_ILPMdChargeunit.isWeightUnit",
          "CTS_ILPMdChargeunit.createOfficeName",
          "CTS_ILPMdChargeunit.createTime",
          "CTS_ILPMdChargeunit.isCubeUnit",
          "CTS_ILPMdChargeunit.settleOffice",
          "CTS_ILPMdChargeunit.mdChargeunitCode",
          "CTS_ILPMdChargeunit.lastModifierName",
          "CTS_ILPMdChargeunit.isAreaUnit",
          "CTS_ILPMdChargeunit.remark",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPackageInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //包装联想控件数据源
    associate_queryMethod_ebCtns_packageType({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
          isActive4: "1",
          isPackageType5: "1",
        };
      } else {
        params = {
          mdChargeunitCode0: "%" + keyword + "%",
          enName1: "%" + keyword + "%",
          cnName2: "%" + keyword + "%",
          isDeleted3: "0",
          isActive4: "1",
          isPackageType5: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdChargeunit.cnName"],
        mainModelName: "CTS_ILPMdChargeunit",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdChargeunit.mdChargeunitCode LIKE :mdChargeunitCode0 OR CTS_ILPMdChargeunit.enName LIKE :enName1) OR CTS_ILPMdChargeunit.cnName LIKE :cnName2) AND CTS_ILPMdChargeunit.isDeleted = :isDeleted3) AND CTS_ILPMdChargeunit.isActive = :isActive4) AND CTS_ILPMdChargeunit.isPackageType = :isPackageType5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdChargeunit.mdChargeunitId",
          "CTS_ILPMdChargeunit.creatorName",
          "CTS_ILPMdChargeunit.isDeleted",
          "CTS_ILPMdChargeunit.lastModifyOfficeName",
          "CTS_ILPMdChargeunit.isChargeUnit",
          "CTS_ILPMdChargeunit.lastModifyTime",
          "CTS_ILPMdChargeunit.isContainerSize",
          "CTS_ILPMdChargeunit.creatorId",
          "CTS_ILPMdChargeunit.createOffice",
          "CTS_ILPMdChargeunit.lastModifyOffice",
          "CTS_ILPMdChargeunit.deptOfficeName",
          "CTS_ILPMdChargeunit.isPackageUnit",
          "CTS_ILPMdChargeunit.enName",
          "CTS_ILPMdChargeunit.isActive",
          "CTS_ILPMdChargeunit.recordVersion",
          "CTS_ILPMdChargeunit.relateCode",
          "CTS_ILPMdChargeunit.principalGroupCode",
          "CTS_ILPMdChargeunit.settleOfficeName",
          "CTS_ILPMdChargeunit.deptOffice",
          "CTS_ILPMdChargeunit.isPackageType",
          "CTS_ILPMdChargeunit.lastModifierId",
          "CTS_ILPMdChargeunit.cnName",
          "CTS_ILPMdChargeunit.ebMdChargeunitId",
          "CTS_ILPMdChargeunit.isWeightUnit",
          "CTS_ILPMdChargeunit.createOfficeName",
          "CTS_ILPMdChargeunit.createTime",
          "CTS_ILPMdChargeunit.isCubeUnit",
          "CTS_ILPMdChargeunit.settleOffice",
          "CTS_ILPMdChargeunit.mdChargeunitCode",
          "CTS_ILPMdChargeunit.lastModifierName",
          "CTS_ILPMdChargeunit.isAreaUnit",
          "CTS_ILPMdChargeunit.remark",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPackageInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 收货地/装货港/中转港/卸货港/交货地联想控件数据源
    associate_queryMethod_po({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
          isActive: "1",
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
          isActive: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5 AND CTS_ILPMdPort.isActive = :isActive)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //获取数据字典
    getSelectList() {
      let self = this;
      queryDictRows(
        "MD_CODE_DICT$EB_ORDER_BK_STATUS,MD_CODE_DICT$FREE_APP_STATUS,MD_CODE_DICT$PAYMENTMODE,MD_CODE_DICT$TRANSPORT_TERM,MD_CODE_DICT$EB_ISSUE_TYPE,MD_CODE_DICT$MD_BK_NO_OF_BILL,CS_AGREEMENT_TYPE$ARG_TYPE,MD_CODE_DICT$EB_MD_CODE_SERVICE_REQUEST,MD_CODE_DICT$FREE_CTN_STATUS,MD_CODE_DICT$BILL_SORTS,MD_CODE_DICT$EB_AMSACI_MODE,MD_CODE_DICT$FCL_LCL"
      ).then((res) => {
        self.amsSendModeList = res.MD_CODE_DICT$EB_AMSACI_MODE
        /*name:value value:key*/
        self.billTypeList = res.MD_CODE_DICT$BILL_SORTS;
        //付款方式
        self.hblPaymentTypeList = res.MD_CODE_DICT$PAYMENTMODE;
        //运输条款
        self.hblTransportTermList = res.MD_CODE_DICT$TRANSPORT_TERM;
        //签单方式
        self.issueModeList = res.MD_CODE_DICT$EB_ISSUE_TYPE;
        //正本份数、副本份数
        self.noOfOriginalList = res.MD_CODE_DICT$MD_BK_NO_OF_BILL;
        // 状态
        self.freeStatus = res.MD_CODE_DICT$FREE_CTN_STATUS;
        //所有服务项
        self.allEbServiceItems = res.MD_CODE_DICT$EB_MD_CODE_SERVICE_REQUEST;
        //整拼标识
        self.FCLLCL = res.MD_CODE_DICT$FCL_LCL;
        self.approvalStatusList = res.MD_CODE_DICT$FREE_APP_STATUS;

        let dict = []
        res.MD_CODE_DICT$FCL_LCL.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = []
          dict.push(param);
        });
        this.$hotTableUtils.registDict({
          FCL_LCL: dict,
        });
      });
    },
    // 获取收发通组件中的数据
    getEbPartyInfo(value) {
      this.ebParty = value;
    },
    // 获取货物信息组件中的数据
    getEbCargoInfo(value) {
      this.ebCargo = value;
    },
    billBoxInfoTableCellClick(row) {
      this.$refs.billBoxInfoTableRef.startEdit(row.physicalRow, row.physicalCol);
    },
    billBoxInfoTableRowClick(value) {
      this.billBoxInfoTableSelectRowIndex = value.row;
      console.log(value)
      if (JSON.stringify(this.billBoxInfoTableRules) === '{}') this.billBoxInfoTableRules = BoxInfoValidate();
      this.billBoxInfoTableRowStatus = true;
      this.ebCtns = value.record;
      this.currentebBlPlanCtnCargo = this.ebCtns.ebBlPlanCtnCargo
    },
    billCargoInfoTableCellClick(row) {
      this.$refs.billCargoInfoTableRef.startEdit(row.physicalRow, row.physicalCol);
    },
    billCargoInfoTableRowClick(value) {
      if (JSON.stringify(this.billCargoInfoTableRules) === '{}') this.billCargoInfoTableRules = BillCargoInfoValidate();
      this.billCargoInfoTableSelectRowIndex = value.row;
    },
    //引用
    quote(){
      let self = this;
      if(!self.ebBlPlan.packageTypeName){
        self.$coreMethods.message( "warning","请先维护货物小计中的包装单位！");
        return;
      }
      if(!self.ebBlPlanCtns || self.ebBlPlanCtns.length === 0){
        self.ebCtnRequests.forEach((item) => {
          for (let i = 0; i < item.ctnQuantity; i++) {
            let addBillBoxInfoObj = {
              ctnNo: "",
              sealNo: "",
              ctnSizeType: item.ctnSizeType,
              noOfPackage: "",
              packageTypeCode: self.ebBlPlan.packageTypeCode,
              packageTypeName: self.ebBlPlan.packageTypeName,
              cube: "",
              grossWeight: "",
              netWeight: "",
              ctnCompanyName: item.ctnCompanyName,
              ctnCompanyCode: "",
              isSoc: item.isSoc,
              fclLclFlag: item.fclLclFlag,
              ebBlPlanCtnCargo: []
            };
            self.ebBlPlanCtns.push(addBillBoxInfoObj);
          }
        });
      }else{
        let checkebCtnRequests = [];
        self.ebCtnRequests.forEach(item => {
          let Obj = {
            ctnSizeType: item.ctnSizeType,
            ctnQuantity: item.ctnQuantity,
            fclLclFlag: item.fclLclFlag,
          };
          checkebCtnRequests.push(Obj)
        });
        self.ebBlPlanCtns.forEach((item1) => {
          checkebCtnRequests.forEach((item2) => {
            if(item1.ctnSizeType === item2.ctnSizeType){
              item2.ctnQuantity = item2.ctnQuantity-1;
              if(item2.ctnQuantity ===0){
                let index = checkebCtnRequests.indexOf(item2);
                checkebCtnRequests.splice(index, 1);
              }
            }
          });
        });
        if(checkebCtnRequests.length>0){
          checkebCtnRequests.forEach((item) => {
            for (let i = 0; i < item.ctnQuantity; i++) {
              let addBillBoxInfoObj = {
                ctnNo: "",
                sealNo: "",
                ctnSizeType: item.ctnSizeType,
                noOfPackage: "",
                packageTypeCode: self.ebBlPlan.packageTypeCode,
                packageTypeName: self.ebBlPlan.packageTypeName,
                cube: "",
                grossWeight: "",
                netWeight: "",
                ctnCompanyName: item.ctnCompanyName,
                ctnCompanyCode: "",
                isSoc: item.isSoc,
                fclLclFlag: item.fclLclFlag,
                ebBlPlanCtnCargo: []
              };
              self.ebBlPlanCtns.push(addBillBoxInfoObj);
            }
          });
        }else{
          self.$coreMethods.message("warning", "数据已引用！");
        }
        console.info(self.ebCtnRequests);
      }
    },
    //箱信息-新增
    addBillBoxInfo() {
      let self = this;
      let addBillBoxInfoObj = {
        ctnNo: "",
        sealNo: "",
        ctnSizeType: "",
        noOfPackage: "",
        packageTypeCode: "",
        cube: "",
        grossWeight: "",
        netWeight: "",
        ctnCompanyName: "",
        ctnCompanyCode: "",
        isSoc: "",
        fclLclFlag: "",
        ebBlPlanCtnCargo: []
      };
      this.ebBlPlanCtns.push(addBillBoxInfoObj);
      this.ebCtns = addBillBoxInfoObj
      this.billBoxInfoTableRowStatus = true;
      if (JSON.stringify(this.billBoxInfoTableRules) === '{}') this.billBoxInfoTableRules = BoxInfoValidate();
      // 新增行高亮
      self.$refs.billBoxInfoTableRef.hotInstance.addHookOnce(
        "afterLoadData",
        function () {
          self.$nextTick(function () {
            self.$refs.billBoxInfoTableRef.hotInstance.selectCell(self.ebBlPlanCtns.length - 1, 1);
          });
        }
      );
    },
    addBillCargoInfo() {
      if (JSON.stringify(this.billCargoInfoTableRules) === '{}') this.billCargoInfoTableRules = BillCargoInfoValidate();
      if (!this.billBoxInfoTableRowStatus) return this.$coreMethods.message("warning", "请先选择箱货信息");
      let newBillCargoObj = {
        ctnNo: this.ebCtns.ctnNo,
        hsCode: "",
        marks: "",
        cargoDescription: "",
        noOfPackage: "",
        packageTypeCode: "",
        netWeight: "",
        grossWeight: "",
        cube: ""
      }
      this.ebCtns.ebBlPlanCtnCargo.push(newBillCargoObj)
    },
    //提单确认编辑[箱货关系-货物信息-删除]
    deleteBillCargoInfo() {
      const selections = this.$refs.billCargoInfoTableRef.getSelections();
      let BillBoxInfoDeleteIds = [];
      let indexList = [];
      let ebBlPlanCtnCargo = this.ebCtns.ebBlPlanCtnCargo;
      if (selections && selections.length > 0) {
        selections.forEach((selection) => {
          if (selection.ebFtPlanCtnCargoId) {
            BillBoxInfoDeleteIds.push(selection.ebCtnId);
          }
          const index = ebBlPlanCtnCargo.indexOf(selection);
          indexList.push(index);
        });
      } else {
        this.$coreMethods.message("warning", "请勾选一条记录");
      }
      //删除逻辑
      if (BillBoxInfoDeleteIds && BillBoxInfoDeleteIds.length > 0) {
      } else {
        let offset = 0;
        indexList.forEach((index) => {
          ebBlPlanCtnCargo.splice(index - offset, 1);
          offset++;
        });
      }
    },
    handleUpload() {
      let self = this;
      if(self.ebBlPlanCtns.length !== 0){
        this.$confirm(
          '提示',
          {
            title: '提示',
            message: '箱货信息已经有值，是否覆盖？',
            confirmButtonText: '确定',
            cancelButtonText: '取消',

          }
        ).then(() => {
          self.$refs['excel-upload-input'].click();
        })
      }else{
        self.$refs['excel-upload-input'].click();
      }
    },
    importLoadingStart() {
      let self = this;
      self.conShow = true;
    },
    importLoadingEnd() {
      let self = this;
      setTimeout(function() {
        self.conShow = false;
      }, 700)
    },
    handleClick() {
      let _this = this;
      let inputDOM = this.$refs.inputer;
      // 通过DOM取文件数据
      this.file = event.currentTarget.files[0];
      let rABS = false; //是否将文件读取为二进制字符串
      let f = this.file;
      let reader = new FileReader();
      //if (!FileReader.prototype.readAsBinaryString) {undefined
      FileReader.prototype.readAsBinaryString = function (f) {
        _this.importLoadingStart();
        let binary = "";
        let rABS = false; //是否将文件读取为二进制字符串
        let pt = this;
        let wb; //读取完成的数据
        let outdata;
        let reader = new FileReader();
        reader.onload = function (e) {
          let bytes = new Uint8Array(reader.result);
          let length = bytes.byteLength;
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          let XLSX = require('xlsx');
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), { //手动转化
              type: 'base64'
            });
          } else {
            wb = XLSX.read(binary, {
              type: 'binary'
            });
          }
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
          outdata = JSON.parse(JSON.stringify(outdata).replaceAll("* ", ""));
          this.da = [...outdata]
          let arr = []
          console.log(outdata);
          this.da.map(item => {
            let obj = {};
            let arr1 = [];
            let value1 = [];
            value1 = Object.values(item);
            arr1 = Object.keys(item);
            let i = 0;
            for (i; i < arr1.length; i++) {
              if (arr1[i] == "箱号") {
                obj.ctnNo = value1[i].toString()
              }
              if (arr1[i] == "铅封号") {
                obj.sealNo = value1[i].toString()
              }
              if (arr1[i] == "箱型尺寸") {
                obj.ctnSizeType = value1[i]
              }
              if (arr1[i] == "装箱件数") {
                obj.noOfPackage = value1[i]
              }
              if (arr1[i] == "包装描述") {
                obj.packageTypeName = value1[i]
              }
              if (arr1[i] == "体积(CBM)") {
                obj.cube = value1[i]
              }
              if (arr1[i] == "装箱毛重(KGS)") {
                obj.grossWeight = value1[i]
              }
              if (arr1[i] == "净重(KGS)") {
                obj.netWeight = value1[i]
              }
              if (arr1[i] == "箱属公司名称") {
                obj.ctnCompanyName = value1[i]
              }
              if (arr1[i] == "箱主代码") {
                obj.ctnCompanyCode = value1[i]
              }
              if (arr1[i] == "SOC") {
                obj.isSoc = value1[i]
              }
              if (arr1[i] == "整拼标记") {
                obj.fclLclFlag = value1[i]
              }

              if (arr1[i] == "报关提单号") {
                obj.mblNo = value1[i]
              }
              if (arr1[i] == "HS CODE") {
                obj.hsCode = value1[i]
              }
              if (arr1[i] == "唛头") {
                obj.marks = value1[i]
              }
              if (arr1[i] == "货物描述") {
                obj.cargoDescription = value1[i]
              }
              if (arr1[i] == "装箱件数") {
                obj.noOfPackage = value1[i]
              }
              if (arr1[i] == "包装描述") {
                obj.packageTypeCode = value1[i]
              }
              if (arr1[i] == "装箱毛重(KGS)") {
                obj.grossWeight = value1[i]
              }
              if (arr1[i] == "装箱体积(CBM)") {
                obj.cube = value1[i]
              }
            }
            arr.push(obj)
          })
          // let checkPackage = false
          // let msgStr = "";
          // let rowIndex = 1;
          // arr.forEach(item => {
          //   if (item.packageTypeCode !== _this.ebBlPlan.packageTypeCode) {
          //     msgStr = msgStr + "第" + rowIndex + "行、";
          //     console.log(item)
          //     checkPackage = true;
          //   }
          //   rowIndex ++;
          // });
          // if(checkPackage){
          //   _this.$refs['excel-upload-input'].value = '';
          //   _this.$coreMethods.message("warning", msgStr + "包装单位不一致，不允许导入");
          //   return;
          // }
          _this.ebBlPlanCtns = [];
          let names = new Set();
          arr.forEach(item => {
            item.ebBlPlanCtnCargo = [];
            let newBillCargoObj = {
              ctnNo: item.ctnNo,
              mblNo: item.mblNo,
              hsCode: item.hsCode,
              marks: item.marks,
              cargoDescription: item.cargoDescription,
              noOfPackage: item.noOfPackage,
              packageTypeName: item.packageTypeName,
              netWeight: item.netWeight,
              grossWeight: item.grossWeight,
              cube: item.cube
            }
            names.add(item.packageTypeName);
            item.ebBlPlanCtnCargo.push(newBillCargoObj);
            let isSame = false;
            _this.ebBlPlanCtns.forEach(x => {
              if(x.ctnNo === item.ctnNo && x.sealNo === item.sealNo && x.ctnSizeType === item.ctnSizeType){
                isSame = true;
                if(item.noOfPackage){
                  x.noOfPackage = x.noOfPackage + item.noOfPackage;
                }
                if(item.grossWeight){
                  x.grossWeight = x.grossWeight + item.grossWeight;
                }
                if(item.cube){
                  x.cube = x.cube + item.cube;
                }
                x.ebBlPlanCtnCargo.push(newBillCargoObj);
              }
            });
            if(!isSame){
              item.packageTypeName = _this.ebBlPlan.packageTypeName;
              item.packageTypeCode = _this.ebBlPlan.packageTypeCode;
              item.grossWeight = newBillCargoObj.grossWeight || 0;
              item.cube = newBillCargoObj.cube || 0;
              _this.ebBlPlanCtns.push(item);
            }
          });
          if(names.length > 0){
            let data = { names: names };
            queryPackageCode(data).then(res => {
              if(res && res.length > 0){
                _this.ebBlPlanCtns.forEach(x => {
                  if(x.ebBlPlanCtnCargo){
                    x.ebBlPlanCtnCargo.forEach(item => {
                      res.forEach(y => {
                        if(item.packageTypeName === y.enName){
                          item.packageTypeCode = y.mdChargeunitCode;
                        }
                      })
                    })
                  }
                })
              }
            })
          }
          _this.$message({message: '导入成功', type: 'success'});
          _this.$refs['excel-upload-input'].value = '';
        }
        reader.readAsArrayBuffer(f);
      }
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
        _this.importLoadingEnd();
    },

    deleteEbBlPlanCtns() {
      let self = this;
      const selections = this.$refs.billBoxInfoTableRef.getSelections();
      let BillBoxInfoDeleteIds = [];
      let indexList = [];
      let ebBlPlanCtns = this.ebBlPlanCtns;
      if (selections && selections.length > 0) {
        selections.forEach((selection) => {
          if (selection.ebBlPlanCtnId) {
            BillBoxInfoDeleteIds.push(selection.ebBlPlanCtnId);
          }
          const index = ebBlPlanCtns.indexOf(selection);
          indexList.push(index);
        });
      } else {
        this.$coreMethods.message("warning", "请勾选一条记录");
      }
      //删除逻辑
      if (BillBoxInfoDeleteIds && BillBoxInfoDeleteIds.length > 0) {
        deteleEbBlPlanCtnById(BillBoxInfoDeleteIds).then((res) => {
          if (res.success) {
            let offset = 0;
            indexList.forEach((index) => {
              ebBlPlanCtns.splice(index - offset, 1);
              offset++;
            });
          }
        });
      } else {
        let offset = 0;
        indexList.forEach((index) => {
          ebBlPlanCtns.splice(index - offset, 1);
          offset++;
        });
      }
      this.ebCtns = {}
      // this.ebBlPlan.ctnNum = null;

      selections.forEach(item => {
        let ctnSizeTypeNum = self.ctnSizeTypeMap.get(item.ctnSizeType);
        ctnSizeTypeNum--;
        self.ctnSizeTypeMap.set(item.ctnSizeType, ctnSizeTypeNum)
      })
      // this.gatherCtnNum();
    },
    // 箱号联想控件数据源
    associate_queryMethod_ctnNo({keyword, pageSize, currentPage}) {
      let params = {
        currentPage: currentPage,
        pageSize: pageSize,
        ctnNo: keyword,
        ebOrderId: this.ebOrder.ebOrderId,
      };
      return new Promise((resolve) => {
        ebCtn.getEbCtn(params).then((res) => {
          resolve({
            records: res.data,
            total: res.data.length,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 箱型尺寸联想控件数据源
    associate_queryMethod_ctnSizeType({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
          isActive: "1",
        };
      } else {
        params = {
          isDeleted0: "%" + keyword + "%",
          containerType1: "%" + keyword + "%",
          isDeleted2: "0",
          isActive: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdContainerType.containerType"],
        mainModelName: "CTS_ILPMdContainerType",
        tag: "CTS_ILP_es",
        where:
          "((CTS_ILPMdContainerType.isDeleted LIKE :isDeleted0 OR CTS_ILPMdContainerType.containerType LIKE :containerType1) AND CTS_ILPMdContainerType.isDeleted = :isDeleted2 AND CTS_ILPMdContainerType.isActive = :isActive)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdContainerType.mdContainerTypeId",
          "CTS_ILPMdContainerType.mdContainerTypeId",
          "CTS_ILPMdContainerType.containerTypeName",
          "CTS_ILPMdContainerType.recordVersion",
          "CTS_ILPMdContainerType.ctnHeight",
          "CTS_ILPMdContainerType.principalGroupCode",
          "CTS_ILPMdContainerType.lastModifierId",
          "CTS_ILPMdContainerType.ctnWeight",
          "CTS_ILPMdContainerType.lastModifyOffice",
          "CTS_ILPMdContainerType.creatorName",
          "CTS_ILPMdContainerType.createOffice",
          "CTS_ILPMdContainerType.teu",
          "CTS_ILPMdContainerType.isActive",
          "CTS_ILPMdContainerType.creatorId",
          "CTS_ILPMdContainerType.createTime",
          "CTS_ILPMdContainerType.lastModifyOfficeName",
          "CTS_ILPMdContainerType.ctnWidth",
          "CTS_ILPMdContainerType.containerSize",
          "CTS_ILPMdContainerType.lastModifyTime",
          "CTS_ILPMdContainerType.ctnDescriptionEn",
          "CTS_ILPMdContainerType.ctnDescriptionCn",
          "CTS_ILPMdContainerType.maxWeight",
          "CTS_ILPMdContainerType.containerType",
          "CTS_ILPMdContainerType.ctnLength",
          "CTS_ILPMdContainerType.lastModifierName",
          "CTS_ILPMdContainerType.isDeleted",
          "CTS_ILPMdContainerType.appCode",
          "CTS_ILPMdContainerType.maxMeas",
          "CTS_ILPMdContainerType.reamrk",
          "CTS_ILPMdContainerType.createOfficeName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryCtnSizeInfo(data).then((res) => {
          console.log("queryCtnSizeInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 船名联想控件数据源
    associate_queryMethod_vessel({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.voyage"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({keyword, pageSize, currentPage}) {
      let params = {};
      let whereObj = null;
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }

      if (this.ebOrder.vesselNameEn) {
        params.vesselId = this.ebOrder.vesselId;
        whereObj =
          "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3 AND CTS_ILPMdVoyagePlan.vesselId = :vesselId)";
      } else {
        whereObj =
          "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)";
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where: whereObj,
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 驳船航次联想控件数据源
    associate_queryMethod_voyage2({keyword, pageSize, currentPage}) {
      let params = {};
      let whereObj = null;
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }
      if (this.ebOrder.bargeVesselName) {
        params.vesselId = this.ebOrder.bargeVesselId;
        whereObj =
          "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3 AND CTS_ILPMdVoyagePlan.vesselId = :vesselId)";
      } else {
        whereObj =
          "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)";
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where: whereObj,
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 作业码头联想控件数据源     IS_ACTIVE = 1 AND IS_DELETED = 0 AND FACILITY_TYPE LIKE '%MT%'
    associate_queryMethod_terminal({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          facilityType: '%MT%',
          isDeleted3: "0",
          isActive: "1",

        };
      } else {
        params = {
          facilityType: '%MT%',
          isDeleted3: "0",
          isActive: "1",
          shortName: "%" + keyword + "%",
          mnemonicCode: "%" + keyword + "%",
          facilityNameCn: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdFacility.facilityType"],
        mainModelName: "CTS_ILPMdFacility",
        tag: "CTS_ILP_es",
        where: "((((((((CTS_ILPMdFacility.shortName LIKE :shortName) OR CTS_ILPMdFacility.shortName LIKE :shortName)) OR CTS_ILPMdFacility.mnemonicCode LIKE :mnemonicCode) OR CTS_ILPMdFacility.facilityNameCn LIKE :facilityNameCn) AND CTS_ILPMdFacility.isDeleted = :isDeleted3) AND CTS_ILPMdFacility.isActive = :isActive)AND CTS_ILPMdFacility.facilityType like :facilityType)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        enableCascade: true,
        fields: [
          "CTS_ILPMdFacility.facilityNameCn",
          "CTS_ILPMdFacility.shortName",
          "CTS_ILPMdFacility.mnemonicCode",
          "CTS_ILPMdFacility.mnemonicCode"
        ],
      };

      return new Promise((resolve) => {
        querybizTypeName(data)
          .then((res) => {
            if (res.success) {
              resolve({
                records: res.data.data,
                total: res.data.totalRecord,
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 拼箱checkBox改变事件
    onChangeIsLcl() {
      let self = this;
      if (self.ebOrder.isLcl === 1) {
        self.ebOrder.bizBigTypeCode = "MFE";
        self.ebOrder.bizBigTypeName = "海运集装箱出口";
      } else if (self.ebOrder.isLcl === 0) {
        self.ebOrder.bizBigTypeCode = "MFE";
        self.ebOrder.bizBigTypeName = "海运集装箱出口";
      }
    },
    // 签单地点
    changePlaceOfIssueName(value, selectedRows) {
      this.ebBlPlan.placeOfIssueName = selectedRows.portNameEn;
      this.ebBlPlan.placeOfIssueId = selectedRows.mdPortId;
      this.ebBlPlan.placeOfIssueCode = selectedRows.portCode;
    },
    // 华贸分公司
    changeCsOffice(value, selectedRows) {
      this.ebOrder.settleOfficeName = selectedRows.corpNameCn;
      this.ebOrder.settleOffice = selectedRows.sysCorpId;
    },
    //华贸客服联想控件改变事件
    onChangeCsOffice(value, selectedRows) {
      this.ebOrder.csName = selectedRows.userNameCn;
      this.ebOrder.csId = selectedRows.sysUserId;
      this.ebOrder.csEmail = selectedRows.email;
      this.ebOrder.csTel = selectedRows.tel;
      this.ebOrder.mobile = selectedRows.mobilePhone;
    },
    //大船船名联想控件修改事件
    onChangeVessel(value, selectedRows) {
      this.ebOrder.vesselId = selectedRows.vesselId;
      this.ebOrder.vesselNameEn = selectedRows.vesselName;
      this.ebOrder.voyage = selectedRows.voyage;
    },
    // 大船航次联想控件修改事件
    onChangeVoyage(value, selectedRows) {
      this.ebOrder.voyage = selectedRows.voyage;
    },
    //驳船船名联想控件修改事件
    onChangeBargeVessel(value, selectedRows) {
      this.ebOrder.bargeVesselId = selectedRows.vesselId;
      this.ebOrder.bargeVesselName = selectedRows.vesselName;
      this.ebOrder.bargeVoyage = selectedRows.voyage;
    },
    //作业码头联想控件修改事件
    onChangeTerminal(value, selectedRows) {
      this.ebOrder.terminalId = selectedRows.mnemonicCode;
      this.ebOrder.terminalName = selectedRows.shortName;
    },
    // 付款地点
    changeMblPaymentPlace(value, selectedRows) {
      this.ebOrder.mblPaymentPlace = selectedRows.portNameEn;
      this.ebOrder.mblPaymentPlaceId = selectedRows.mdPortId;
    },
    //驳船作业码头联想控件修改事件
    onChangeBargeTerminal(value, selectedRows) {
      this.ebOrder.bargeTerminalId = selectedRows.mnemonicCode;
      this.ebOrder.bargeTerminalName = selectedRows.shortName;
    },
    //收货地联想控件修改事件
    onChangePor(value, selectedRows) {
      this.ebOrder.porId = selectedRows.mdPortId;
      this.ebOrder.porCode = selectedRows.portCode;
      this.ebBlPlan.blPorName = selectedRows.portNameEn
    },
    //装货港联想控件修改事件
    onChangePol(value, selectedRows) {
      this.ebOrder.polId = selectedRows.mdPortId;
      this.ebOrder.polCode = selectedRows.portCode;
      this.ebBlPlan.blPolName = selectedRows.portNameEn
    },
    //中转港联想控件修改事件
    onChangePot(value, selectedRows) {
      this.ebOrder.potId = selectedRows.mdPortId;
      this.ebOrder.potCode = selectedRows.portCode;
      this.ebBlPlan.blPotName = selectedRows.portNameEn
    },
    //卸货港联想控件修改事件
    onChangePod(value, selectedRows) {
      this.ebOrder.podId = selectedRows.mdPortId;
      this.ebOrder.podCode = selectedRows.portCode;
      this.ebBlPlan.blPodName = selectedRows.portNameEn
    },
    //交货地联想控件修改事件
    onChangePlaceOfDelivery(value, selectedRows) {
      this.ebOrder.placeOfDeliveryId = selectedRows.mdPortId;
      this.ebOrder.placeOfDeliveryCode = selectedRows.portCode;
      this.ebBlPlan.blPlaceOfDeliveryName = selectedRows.portNameEn
    },
    //箱公司联想控件修改事件
    onChangeCtnCompany(value, selectedRows) {
      // this.ebOrder.ctnCompanyId = selectedRows.csCustId;
      this.ebCtnRequests[this._index].ctnCompanyId = selectedRows.csCustId;
    },
    //服务项修改事件
    onChangeEbServiceItem(val) {
      console.log("ebServiceItemList", this.ebServiceItemList);
    },
    // 箱货表格箱号修改事件
    boxCtnNoChange(value, selectedRows) {
      const billBoxInfoTableSelectRowData = this.ebBlPlanCtns[this.billBoxInfoTableSelectRowIndex];
      // for (const key in billBoxInfoTableSelectRowData) {
      //   if (selectedRows[key]) {
      //     billBoxInfoTableSelectRowData[key] = selectedRows[key];
      //   }
      // }
      if(selectedRows["ebCtnId"]){
        billBoxInfoTableSelectRowData["ctnNo"] = selectedRows["ctnNo"];
        billBoxInfoTableSelectRowData["sealNo"] = selectedRows["sealNo"];
        billBoxInfoTableSelectRowData["ctnSizeType"] = selectedRows["ctnSizeType"];
      }
      if(this.billBoxInfoTableRowStatus && this.currentebBlPlanCtnCargo){
        this.currentebBlPlanCtnCargo.forEach(item => {
          item.ctnNo = billBoxInfoTableSelectRowData.ctnNo;
        });
      }
    },
  },
  beforeDestroy() {
    let _this = this;
    // 离开页面删除检测器和所有侦听器
    _this.resizeObserver.disconnect();
  },
}
</script>

<style scoped lang="scss">

#Loading {
  top:50%;
  left:50%;
  margin: auto;
  position: fixed;
  -webkit-transform: translateY(-50%)  translateX(-50%);
  transform: translateY(-50%)  translateX(-50%);
  z-index:9999;
}
@-webkit-keyframes ball-beat {
  50% {
    opacity: 0.2;
    -webkit-transform: scale(0.75);
    transform: scale(0.75); }

  100% {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1); } }

@keyframes ball-beat {
  50% {
    opacity: 0.2;
    -webkit-transform: scale(0.75);
    transform: scale(0.75); }

  100% {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1); } }

.ball-beat > div {
  background-color: #5D9BFF;
  width: 15px;
  height: 15px;
  border-radius: 100% !important;
  margin: 2px;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: inline-block;
  -webkit-animation: ball-beat 0.7s 0s infinite linear;
  animation: ball-beat 0.7s 0s infinite linear; }
.ball-beat > div:nth-child(2n-1) {
  -webkit-animation-delay: 0.35s !important;
  animation-delay: 0.35s !important; }


.el-scrollbar ::v-deep .el-scrollbar__wrap {
  height: 125px;

  .el-scrollbar__view {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .node-content {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 220px;

      .node-content-img {
        width: 50px;
        background-size: 100% 100%;
      }

      .solid-style {
        height: 1px;
        border-top: 2px solid #e58660;
        width: 173px;
        position: absolute;
        top: 30px;
        left: 134px;
      }

      .dashed-style {
        height: 1px;
        border-top: 2px solid #d7d7d7;
        width: 173px;
        position: absolute;
        top: 30px;
        left: 134px;
      }

      .node-content-name {
        margin-top: 4px;
      }

      .node-content-date {
        font-size: 12px;
        margin-top: 4px;
        width: 80px;
        text-align: center;
        white-space: pre-wrap;
      }
    }
  }
}

.ulStyle {
  display: flex;
  justify-content: flex-start;
  align-content: center;
  height: 80px;
  padding-left: 0px;
  width: 100%;

  .liContainer {
    display: flex;
    justify-content: flex-start;
    align-content: center;
    width: calc(100% - 80px);
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
  }

  li {
    list-style: none;
  }
}

.node-img {
  // width:118px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.solid-style {
  height: 1px;
  border-top: 2px solid #d7d7d7;
  width: 94px;
  position: absolute;
  top: 10px;
  left: 71px;
}

.dashed-style {
  height: 1px;
  border-top: 2px dashed #d7d7d7;
  width: 94px;
  position: absolute;
  top: 10px;
  left: 71px;
}

.success-style {
  background: #70ac47;
}

.wait-style {
  background: #edb300;
}

.next-style {
  background: #a5a5a5;
}

.warn-style {
  background: #f00000;
}

.ring-style {
  background: #a5a5a5;
}

.success-style,
.wait-style,
.next-style,
.warn-style,
.ring-style {
  font-size: 12px;
  color: #ffffff;
  padding: 0px 8px 4px 8px;
  border-radius: 20px;
  padding-top: 5px;
  white-space: nowrap;
  margin: 3px 0px;
}

::v-deep.is-required .el-form-item__label {
  color: red !important;
}
.billedit-transceiver{
 background-color:#fff;
 border-radius: 10px;
 margin-bottom:18px;
}
  .icon-none-info {
    width: 120px;
    height: 90px;
    margin: 25px auto;
  }
</style>
